/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as R404RouteImport } from "./routes/404"
import { Route as DashboardRouteImport } from "./routes/_dashboard"
import { Route as OauthRouteImport } from "./routes/_oauth"
import { Route as PublicRouteImport } from "./routes/_public"
import { Route as DashboardDatasetSlugRouteImport } from "./routes/_dashboard/$datasetSlug"
import { Route as PublicLoginRouteImport } from "./routes/_public/login"
import { Route as PublicMagicLinkSentRouteImport } from "./routes/_public/magic-link-sent"
import { Route as PublicMfaRouteImport } from "./routes/_public/mfa"
import { Route as PublicOpenapiOauthRouteImport } from "./routes/_public/openapi-oauth"
import { Route as PublicSelectDatasetRouteImport } from "./routes/_public/select-dataset"
import { Route as PublicVerifyRouteImport } from "./routes/_public/verify"
import { Route as PublicVerifyUserDatasetRouteImport } from "./routes/_public/verify-user-dataset"
import { Route as DashboardDatasetSlugAppsRouteImport } from "./routes/_dashboard/$datasetSlug/apps"
import { Route as DashboardDatasetSlugComplianceRouteImport } from "./routes/_dashboard/$datasetSlug/compliance"
import { Route as DashboardDatasetSlugDashboardRouteImport } from "./routes/_dashboard/$datasetSlug/dashboard"
import { Route as DashboardDatasetSlugProfileRouteImport } from "./routes/_dashboard/$datasetSlug/profile"
import { Route as DashboardDatasetSlugSearchRouteImport } from "./routes/_dashboard/$datasetSlug/search"
import { Route as DashboardDatasetSlugSettingsRouteRouteImport } from "./routes/_dashboard/$datasetSlug/settings/route"
import { Route as OauthOauthResponseRouteImport } from "./routes/_oauth/oauth/response"
import { Route as OauthOauthVerifyLinkAccountRequestRouteImport } from "./routes/_oauth/oauth/verify-link-account-request"
import { Route as OauthOauthVerifyNewAccountRequestRouteImport } from "./routes/_oauth/oauth/verify-new-account-request"
import { Route as OauthOauthVerifyNewUserSignupRouteImport } from "./routes/_oauth/oauth/verify-new-user-signup"
import { Route as DashboardDatasetSlugchatsChatsRouteImport } from "./routes/_dashboard/$datasetSlug/(chats)/chats"
import { Route as DashboardDatasetSlugAppsIndexRouteImport } from "./routes/_dashboard/$datasetSlug/apps.index"
import { Route as DashboardDatasetSlugAppsSlugRouteImport } from "./routes/_dashboard/$datasetSlug/apps.$slug"
import { Route as DashboardDatasetSlugAutomationsIndexRouteImport } from "./routes/_dashboard/$datasetSlug/automations.index"
import { Route as DashboardDatasetSlugAutomationsNew_automationRouteImport } from "./routes/_dashboard/$datasetSlug/automations/new_automation"
import { Route as DashboardDatasetSlugCustomUiIdRouteImport } from "./routes/_dashboard/$datasetSlug/custom-ui/$id"
import { Route as DashboardDatasetSlugDataApplicationsRouteRouteImport } from "./routes/_dashboard/$datasetSlug/data/applications/route"
import { Route as DashboardDatasetSlugDocsIndexRouteImport } from "./routes/_dashboard/$datasetSlug/docs/index"
import { Route as DashboardDatasetSlugDocsSplatRouteImport } from "./routes/_dashboard/$datasetSlug/docs/$"
import { Route as DashboardDatasetSlugLibraryIndexRouteImport } from "./routes/_dashboard/$datasetSlug/library/index"
import { Route as DashboardDatasetSlugNotesIndexRouteImport } from "./routes/_dashboard/$datasetSlug/notes.index"
import { Route as DashboardDatasetSlugNotesCreateRouteImport } from "./routes/_dashboard/$datasetSlug/notes.create"
import { Route as DashboardDatasetSlugPluginsIdRouteImport } from "./routes/_dashboard/$datasetSlug/plugins/$id"
import { Route as DashboardDatasetSlugSearchEntityTypeRouteImport } from "./routes/_dashboard/$datasetSlug/search.$entityType"
import { Route as DashboardDatasetSlugSettingsAiAgentsRouteImport } from "./routes/_dashboard/$datasetSlug/settings/ai-agents"
import { Route as DashboardDatasetSlugSettingsAiSkillsRouteImport } from "./routes/_dashboard/$datasetSlug/settings/ai-skills"
import { Route as DashboardDatasetSlugSettingsApiRouteImport } from "./routes/_dashboard/$datasetSlug/settings/api"
import { Route as DashboardDatasetSlugSettingsApplicationsRouteImport } from "./routes/_dashboard/$datasetSlug/settings/applications"
import { Route as DashboardDatasetSlugSettingsCustomUiRouteImport } from "./routes/_dashboard/$datasetSlug/settings/custom-ui"
import { Route as DashboardDatasetSlugSettingsFilesRouteImport } from "./routes/_dashboard/$datasetSlug/settings/files"
import { Route as DashboardDatasetSlugSettingsGlobalAiSettingsRouteImport } from "./routes/_dashboard/$datasetSlug/settings/global-ai-settings"
import { Route as DashboardDatasetSlugSettingsInterviewsRouteImport } from "./routes/_dashboard/$datasetSlug/settings/interviews"
import { Route as DashboardDatasetSlugSettingsLiveAgentsRouteImport } from "./routes/_dashboard/$datasetSlug/settings/live-agents"
import { Route as DashboardDatasetSlugSettingsPluginsRouteImport } from "./routes/_dashboard/$datasetSlug/settings/plugins"
import { Route as DashboardDatasetSlugSettingsSecurityRouteImport } from "./routes/_dashboard/$datasetSlug/settings/security"
import { Route as DashboardDatasetSlugSettingsSubmissionsRouteImport } from "./routes/_dashboard/$datasetSlug/settings/submissions"
import { Route as DashboardDatasetSlugSettingsTagsRouteImport } from "./routes/_dashboard/$datasetSlug/settings/tags"
import { Route as DashboardDatasetSlugSettingsUsersRouteImport } from "./routes/_dashboard/$datasetSlug/settings/users"
import { Route as DashboardDatasetSlugSupportIndexRouteImport } from "./routes/_dashboard/$datasetSlug/support/index"
import { Route as DashboardDatasetSlugSupportTicketIdRouteImport } from "./routes/_dashboard/$datasetSlug/support/$ticketId"
import { Route as DashboardDatasetSlugSupportNewRouteImport } from "./routes/_dashboard/$datasetSlug/support/new"
import { Route as DashboardDatasetSlugTasksIndexRouteImport } from "./routes/_dashboard/$datasetSlug/tasks/index"
import { Route as DashboardDatasetSlugTasksTaskIdRouteImport } from "./routes/_dashboard/$datasetSlug/tasks/$taskId"
import { Route as DashboardDatasetSlugTasksStatisticsRouteImport } from "./routes/_dashboard/$datasetSlug/tasks/statistics"
import { Route as DashboardDatasetSlugchatsChatsConversationIdRouteImport } from "./routes/_dashboard/$datasetSlug/(chats)/chats.$conversationId"
import { Route as DashboardDatasetSlugAppsInstalledIndexRouteImport } from "./routes/_dashboard/$datasetSlug/apps.installed.index"
import { Route as DashboardDatasetSlugAppsSyncsIndexRouteImport } from "./routes/_dashboard/$datasetSlug/apps.syncs.index"
import { Route as DashboardDatasetSlugAppsSyncsSourceIdRouteImport } from "./routes/_dashboard/$datasetSlug/apps.syncs.$sourceId"
import { Route as DashboardDatasetSlugAppsSyncsWritebacksRouteImport } from "./routes/_dashboard/$datasetSlug/apps.syncs.writebacks"
import { Route as DashboardDatasetSlugAppsInstalledAppIdRouteImport } from "./routes/_dashboard/$datasetSlug/apps_.installed.$appId"
import { Route as DashboardDatasetSlugAutomationsAutomationIdIndexRouteImport } from "./routes/_dashboard/$datasetSlug/automations/$automationId.index"
import { Route as DashboardDatasetSlugAutomationsAutomationIdBuilderRouteImport } from "./routes/_dashboard/$datasetSlug/automations/$automationId.builder"
import { Route as DashboardDatasetSlugAutomationsAutomationIdLogsRouteImport } from "./routes/_dashboard/$datasetSlug/automations/$automationId.logs"
import { Route as DashboardDatasetSlugDataApplicationsActivitiesRouteImport } from "./routes/_dashboard/$datasetSlug/data/applications/activities"
import { Route as DashboardDatasetSlugDataApplicationsListRouteImport } from "./routes/_dashboard/$datasetSlug/data/applications/list"
import { Route as DashboardDatasetSlugDataCandidatesIndexRouteImport } from "./routes/_dashboard/$datasetSlug/data/candidates/index"
import { Route as DashboardDatasetSlugDataCandidatesCandidateIdRouteImport } from "./routes/_dashboard/$datasetSlug/data/candidates/$candidateId"
import { Route as DashboardDatasetSlugDataCandidatesCreateRouteImport } from "./routes/_dashboard/$datasetSlug/data/candidates/create"
import { Route as DashboardDatasetSlugDataCandidatesSettingsRouteImport } from "./routes/_dashboard/$datasetSlug/data/candidates/settings"
import { Route as DashboardDatasetSlugDataClientsIndexRouteImport } from "./routes/_dashboard/$datasetSlug/data/clients/index"
import { Route as DashboardDatasetSlugDataClientsClientIdRouteImport } from "./routes/_dashboard/$datasetSlug/data/clients.$clientId"
import { Route as DashboardDatasetSlugDataClientsCreateRouteImport } from "./routes/_dashboard/$datasetSlug/data/clients/create"
import { Route as DashboardDatasetSlugDataClientsSettingsRouteImport } from "./routes/_dashboard/$datasetSlug/data/clients/settings"
import { Route as DashboardDatasetSlugDataContactsIndexRouteImport } from "./routes/_dashboard/$datasetSlug/data/contacts/index"
import { Route as DashboardDatasetSlugDataContactsContactIdRouteImport } from "./routes/_dashboard/$datasetSlug/data/contacts.$contactId"
import { Route as DashboardDatasetSlugDataContactsCreateRouteImport } from "./routes/_dashboard/$datasetSlug/data/contacts/create"
import { Route as DashboardDatasetSlugDataContactsSettingsRouteImport } from "./routes/_dashboard/$datasetSlug/data/contacts/settings"
import { Route as DashboardDatasetSlugDataCustomCreateRouteImport } from "./routes/_dashboard/$datasetSlug/data/custom/create"
import { Route as DashboardDatasetSlugDataCvSendsIndexRouteImport } from "./routes/_dashboard/$datasetSlug/data/cv-sends/index"
import { Route as DashboardDatasetSlugDataJobSubmissionsIndexRouteImport } from "./routes/_dashboard/$datasetSlug/data/job-submissions/index"
import { Route as DashboardDatasetSlugDataJobsIndexRouteImport } from "./routes/_dashboard/$datasetSlug/data/jobs/index"
import { Route as DashboardDatasetSlugDataJobsJobIdRouteImport } from "./routes/_dashboard/$datasetSlug/data/jobs.$jobId"
import { Route as DashboardDatasetSlugDataJobsCreateRouteImport } from "./routes/_dashboard/$datasetSlug/data/jobs/create"
import { Route as DashboardDatasetSlugDataJobsSettingsRouteImport } from "./routes/_dashboard/$datasetSlug/data/jobs/settings"
import { Route as DashboardDatasetSlugDataListsIndexRouteImport } from "./routes/_dashboard/$datasetSlug/data/lists/index"
import { Route as DashboardDatasetSlugDataListsListIdRouteImport } from "./routes/_dashboard/$datasetSlug/data/lists/$listId"
import { Route as DashboardDatasetSlugDataPlacementsIndexRouteImport } from "./routes/_dashboard/$datasetSlug/data/placements/index"
import { Route as DashboardDatasetSlugDataPlacementsSettingsRouteImport } from "./routes/_dashboard/$datasetSlug/data/placements/settings"
import { Route as DashboardDatasetSlugDataSkillsIndexRouteImport } from "./routes/_dashboard/$datasetSlug/data/skills/index"
import { Route as DashboardDatasetSlugDataSkillsSkillIdRouteImport } from "./routes/_dashboard/$datasetSlug/data/skills/$skillId"
import { Route as DashboardDatasetSlugDataSkillsReviewRouteImport } from "./routes/_dashboard/$datasetSlug/data/skills/review"
import { Route as DashboardDatasetSlugDataSkillsSettingsRouteImport } from "./routes/_dashboard/$datasetSlug/data/skills/settings"
import { Route as DashboardDatasetSlugNotesIdEditRouteImport } from "./routes/_dashboard/$datasetSlug/notes.$id.edit"
import { Route as DashboardDatasetSlugSettingsAiAgentsIdRouteImport } from "./routes/_dashboard/$datasetSlug/settings/ai-agents_.$id"
import { Route as DashboardDatasetSlugSettingsAiAgentsCreateRouteImport } from "./routes/_dashboard/$datasetSlug/settings/ai-agents_.create"
import { Route as DashboardDatasetSlugSettingsEmailSettingsIndexRouteImport } from "./routes/_dashboard/$datasetSlug/settings/email-settings/index"
import { Route as DashboardDatasetSlugSettingsLinkedAccountsIndexRouteImport } from "./routes/_dashboard/$datasetSlug/settings/linked-accounts/index"
import { Route as DashboardDatasetSlugSettingsLiveAgentsIdRouteImport } from "./routes/_dashboard/$datasetSlug/settings/live-agents_.$id"
import { Route as DashboardDatasetSlugSettingsLiveAgentsCreateRouteImport } from "./routes/_dashboard/$datasetSlug/settings/live-agents_.create"
import { Route as DashboardDatasetSlugSettingsPermissionsIndexRouteImport } from "./routes/_dashboard/$datasetSlug/settings/permissions/index"
import { Route as DashboardDatasetSlugSettingsPermissionsCreateRouteImport } from "./routes/_dashboard/$datasetSlug/settings/permissions/create"
import { Route as DashboardDatasetSlugSettingsTagsIdRouteImport } from "./routes/_dashboard/$datasetSlug/settings/tags_.$id"
import { Route as DashboardDatasetSlugAppsSyncsSourceIdSourceObjectIdRouteImport } from "./routes/_dashboard/$datasetSlug/apps.syncs.$sourceId.$sourceObjectId"
import { Route as DashboardDatasetSlugAutomationsAutomationIdLogsJourneyIdRouteImport } from "./routes/_dashboard/$datasetSlug/automations/$automationId.logs.$journeyId"
import { Route as DashboardDatasetSlugDataApplicationsListApplicationIdRouteImport } from "./routes/_dashboard/$datasetSlug/data/applications/list.$applicationId"
import { Route as DashboardDatasetSlugDataApplicationsTableIndexRouteImport } from "./routes/_dashboard/$datasetSlug/data/applications/table/index"
import { Route as DashboardDatasetSlugDataApplicationsTableApplicationIdRouteImport } from "./routes/_dashboard/$datasetSlug/data/applications/table/$applicationId"
import { Route as DashboardDatasetSlugDataCandidatesEditIdRouteImport } from "./routes/_dashboard/$datasetSlug/data/candidates/edit/$id"
import { Route as DashboardDatasetSlugDataCandidatesViewViewNameRouteImport } from "./routes/_dashboard/$datasetSlug/data/candidates/view/$viewName"
import { Route as DashboardDatasetSlugDataClientsEditIdRouteImport } from "./routes/_dashboard/$datasetSlug/data/clients/edit/$id"
import { Route as DashboardDatasetSlugDataClientsViewViewNameRouteImport } from "./routes/_dashboard/$datasetSlug/data/clients/view/$viewName"
import { Route as DashboardDatasetSlugDataContactsEditIdRouteImport } from "./routes/_dashboard/$datasetSlug/data/contacts/edit.$id"
import { Route as DashboardDatasetSlugDataContactsViewViewNameRouteImport } from "./routes/_dashboard/$datasetSlug/data/contacts/view/$viewName"
import { Route as DashboardDatasetSlugDataJobsEditIdRouteImport } from "./routes/_dashboard/$datasetSlug/data/jobs/edit/$id"
import { Route as DashboardDatasetSlugDataJobsViewViewNameRouteImport } from "./routes/_dashboard/$datasetSlug/data/jobs/view/$viewName"
import { Route as DashboardDatasetSlugDataSkillsSetsIndexRouteImport } from "./routes/_dashboard/$datasetSlug/data/skills/sets/index"
import { Route as DashboardDatasetSlugDataSkillsSetsSet_idRouteImport } from "./routes/_dashboard/$datasetSlug/data/skills/sets/$set_id"
import { Route as DashboardDatasetSlugSettingsEmailSettingsSyncSettingsIndexRouteImport } from "./routes/_dashboard/$datasetSlug/settings/email-settings/sync-settings/index"
import { Route as DashboardDatasetSlugSettingsEmailSettingsTemplatesIndexRouteImport } from "./routes/_dashboard/$datasetSlug/settings/email-settings/templates/index"
import { Route as DashboardDatasetSlugSettingsEmailSettingsTemplatesCreateRouteImport } from "./routes/_dashboard/$datasetSlug/settings/email-settings/templates/create"
import { Route as DashboardDatasetSlugSettingsLiveAgentsIdIndexRouteImport } from "./routes/_dashboard/$datasetSlug/settings/live-agents_.$id.index"
import { Route as DashboardDatasetSlugSettingsLiveAgentsIdEditRouteImport } from "./routes/_dashboard/$datasetSlug/settings/live-agents_.$id.edit"
import { Route as DashboardDatasetSlugSettingsLiveAgentsIdRunsRouteImport } from "./routes/_dashboard/$datasetSlug/settings/live-agents_.$id.runs"
import { Route as DashboardDatasetSlugSettingsPermissionsEditIdRouteImport } from "./routes/_dashboard/$datasetSlug/settings/permissions/edit/$id"
import { Route as DashboardDatasetSlugSettingsUsersIdEditRouteImport } from "./routes/_dashboard/$datasetSlug/settings/users.$id.edit"
import { Route as DashboardDatasetSlugchatsChatsConversationIdSearchesSearchIdRouteImport } from "./routes/_dashboard/$datasetSlug/(chats)/chats_.$conversationId.searches.$searchId"
import { Route as DashboardDatasetSlugDataCustomDetailsIdCreateRouteImport } from "./routes/_dashboard/$datasetSlug/data/custom/details/$id/create"
import { Route as DashboardDatasetSlugDataCustomDetailsIdKanbanRouteImport } from "./routes/_dashboard/$datasetSlug/data/custom/details/$id/kanban"
import { Route as DashboardDatasetSlugDataCustomDetailsIdSettingsRouteImport } from "./routes/_dashboard/$datasetSlug/data/custom/details/$id/settings"
import { Route as DashboardDatasetSlugSettingsEmailSettingsTemplatesEditIdRouteImport } from "./routes/_dashboard/$datasetSlug/settings/email-settings/templates/edit/$id"
import { Route as DashboardDatasetSlugSettingsLiveAgentsIdRunsIndexRouteImport } from "./routes/_dashboard/$datasetSlug/settings/live-agents_.$id.runs.index"
import { Route as DashboardDatasetSlugSettingsLiveAgentsIdRunsRunIdRouteImport } from "./routes/_dashboard/$datasetSlug/settings/live-agents_.$id.runs.$runId"
import { Route as DashboardDatasetSlugDataCustomDetailsIdEditRowIdRouteImport } from "./routes/_dashboard/$datasetSlug/data/custom/details/$id/edit/$rowId"
import { Route as DashboardDatasetSlugDataCustomDetailsIdTableIndexRouteImport } from "./routes/_dashboard/$datasetSlug/data/custom/details/$id/table/index"
import { Route as DashboardDatasetSlugDataCustomDetailsIdTableCustomDetailsIdRouteImport } from "./routes/_dashboard/$datasetSlug/data/custom/details/$id/table/$customDetailsId"
import { Route as DashboardDatasetSlugDataCustomDetailsIdViewViewNameRouteImport } from "./routes/_dashboard/$datasetSlug/data/custom/details/$id/view/$viewName"

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: "/404",
  path: "/404",
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: "/_dashboard",
  getParentRoute: () => rootRouteImport,
} as any)
const OauthRoute = OauthRouteImport.update({
  id: "/_oauth",
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: "/_public",
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardDatasetSlugRoute = DashboardDatasetSlugRouteImport.update({
  id: "/$datasetSlug",
  path: "/$datasetSlug",
  getParentRoute: () => DashboardRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => PublicRoute,
} as any)
const PublicMagicLinkSentRoute = PublicMagicLinkSentRouteImport.update({
  id: "/magic-link-sent",
  path: "/magic-link-sent",
  getParentRoute: () => PublicRoute,
} as any)
const PublicMfaRoute = PublicMfaRouteImport.update({
  id: "/mfa",
  path: "/mfa",
  getParentRoute: () => PublicRoute,
} as any)
const PublicOpenapiOauthRoute = PublicOpenapiOauthRouteImport.update({
  id: "/openapi-oauth",
  path: "/openapi-oauth",
  getParentRoute: () => PublicRoute,
} as any)
const PublicSelectDatasetRoute = PublicSelectDatasetRouteImport.update({
  id: "/select-dataset",
  path: "/select-dataset",
  getParentRoute: () => PublicRoute,
} as any)
const PublicVerifyRoute = PublicVerifyRouteImport.update({
  id: "/verify",
  path: "/verify",
  getParentRoute: () => PublicRoute,
} as any)
const PublicVerifyUserDatasetRoute = PublicVerifyUserDatasetRouteImport.update({
  id: "/verify-user-dataset",
  path: "/verify-user-dataset",
  getParentRoute: () => PublicRoute,
} as any)
const DashboardDatasetSlugAppsRoute =
  DashboardDatasetSlugAppsRouteImport.update({
    id: "/apps",
    path: "/apps",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugComplianceRoute =
  DashboardDatasetSlugComplianceRouteImport.update({
    id: "/compliance",
    path: "/compliance",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDashboardRoute =
  DashboardDatasetSlugDashboardRouteImport.update({
    id: "/dashboard",
    path: "/dashboard",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugProfileRoute =
  DashboardDatasetSlugProfileRouteImport.update({
    id: "/profile",
    path: "/profile",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugSearchRoute =
  DashboardDatasetSlugSearchRouteImport.update({
    id: "/search",
    path: "/search",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugSettingsRouteRoute =
  DashboardDatasetSlugSettingsRouteRouteImport.update({
    id: "/settings",
    path: "/settings",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const OauthOauthResponseRoute = OauthOauthResponseRouteImport.update({
  id: "/oauth/response",
  path: "/oauth/response",
  getParentRoute: () => OauthRoute,
} as any)
const OauthOauthVerifyLinkAccountRequestRoute =
  OauthOauthVerifyLinkAccountRequestRouteImport.update({
    id: "/oauth/verify-link-account-request",
    path: "/oauth/verify-link-account-request",
    getParentRoute: () => OauthRoute,
  } as any)
const OauthOauthVerifyNewAccountRequestRoute =
  OauthOauthVerifyNewAccountRequestRouteImport.update({
    id: "/oauth/verify-new-account-request",
    path: "/oauth/verify-new-account-request",
    getParentRoute: () => OauthRoute,
  } as any)
const OauthOauthVerifyNewUserSignupRoute =
  OauthOauthVerifyNewUserSignupRouteImport.update({
    id: "/oauth/verify-new-user-signup",
    path: "/oauth/verify-new-user-signup",
    getParentRoute: () => OauthRoute,
  } as any)
const DashboardDatasetSlugchatsChatsRoute =
  DashboardDatasetSlugchatsChatsRouteImport.update({
    id: "/(chats)/chats",
    path: "/chats",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugAppsIndexRoute =
  DashboardDatasetSlugAppsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashboardDatasetSlugAppsRoute,
  } as any)
const DashboardDatasetSlugAppsSlugRoute =
  DashboardDatasetSlugAppsSlugRouteImport.update({
    id: "/$slug",
    path: "/$slug",
    getParentRoute: () => DashboardDatasetSlugAppsRoute,
  } as any)
const DashboardDatasetSlugAutomationsIndexRoute =
  DashboardDatasetSlugAutomationsIndexRouteImport.update({
    id: "/automations/",
    path: "/automations/",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugAutomationsNew_automationRoute =
  DashboardDatasetSlugAutomationsNew_automationRouteImport.update({
    id: "/automations/new_automation",
    path: "/automations/new_automation",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugCustomUiIdRoute =
  DashboardDatasetSlugCustomUiIdRouteImport.update({
    id: "/custom-ui/$id",
    path: "/custom-ui/$id",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataApplicationsRouteRoute =
  DashboardDatasetSlugDataApplicationsRouteRouteImport.update({
    id: "/data/applications",
    path: "/data/applications",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDocsIndexRoute =
  DashboardDatasetSlugDocsIndexRouteImport.update({
    id: "/docs/",
    path: "/docs/",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDocsSplatRoute =
  DashboardDatasetSlugDocsSplatRouteImport.update({
    id: "/docs/$",
    path: "/docs/$",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugLibraryIndexRoute =
  DashboardDatasetSlugLibraryIndexRouteImport.update({
    id: "/library/",
    path: "/library/",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugNotesIndexRoute =
  DashboardDatasetSlugNotesIndexRouteImport.update({
    id: "/notes/",
    path: "/notes/",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugNotesCreateRoute =
  DashboardDatasetSlugNotesCreateRouteImport.update({
    id: "/notes/create",
    path: "/notes/create",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugPluginsIdRoute =
  DashboardDatasetSlugPluginsIdRouteImport.update({
    id: "/plugins/$id",
    path: "/plugins/$id",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugSearchEntityTypeRoute =
  DashboardDatasetSlugSearchEntityTypeRouteImport.update({
    id: "/$entityType",
    path: "/$entityType",
    getParentRoute: () => DashboardDatasetSlugSearchRoute,
  } as any)
const DashboardDatasetSlugSettingsAiAgentsRoute =
  DashboardDatasetSlugSettingsAiAgentsRouteImport.update({
    id: "/ai-agents",
    path: "/ai-agents",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugSettingsAiSkillsRoute =
  DashboardDatasetSlugSettingsAiSkillsRouteImport.update({
    id: "/ai-skills",
    path: "/ai-skills",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugSettingsApiRoute =
  DashboardDatasetSlugSettingsApiRouteImport.update({
    id: "/api",
    path: "/api",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugSettingsApplicationsRoute =
  DashboardDatasetSlugSettingsApplicationsRouteImport.update({
    id: "/applications",
    path: "/applications",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugSettingsCustomUiRoute =
  DashboardDatasetSlugSettingsCustomUiRouteImport.update({
    id: "/custom-ui",
    path: "/custom-ui",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugSettingsFilesRoute =
  DashboardDatasetSlugSettingsFilesRouteImport.update({
    id: "/files",
    path: "/files",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugSettingsGlobalAiSettingsRoute =
  DashboardDatasetSlugSettingsGlobalAiSettingsRouteImport.update({
    id: "/global-ai-settings",
    path: "/global-ai-settings",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugSettingsInterviewsRoute =
  DashboardDatasetSlugSettingsInterviewsRouteImport.update({
    id: "/interviews",
    path: "/interviews",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugSettingsLiveAgentsRoute =
  DashboardDatasetSlugSettingsLiveAgentsRouteImport.update({
    id: "/live-agents",
    path: "/live-agents",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugSettingsPluginsRoute =
  DashboardDatasetSlugSettingsPluginsRouteImport.update({
    id: "/plugins",
    path: "/plugins",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugSettingsSecurityRoute =
  DashboardDatasetSlugSettingsSecurityRouteImport.update({
    id: "/security",
    path: "/security",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugSettingsSubmissionsRoute =
  DashboardDatasetSlugSettingsSubmissionsRouteImport.update({
    id: "/submissions",
    path: "/submissions",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugSettingsTagsRoute =
  DashboardDatasetSlugSettingsTagsRouteImport.update({
    id: "/tags",
    path: "/tags",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugSettingsUsersRoute =
  DashboardDatasetSlugSettingsUsersRouteImport.update({
    id: "/users",
    path: "/users",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugSupportIndexRoute =
  DashboardDatasetSlugSupportIndexRouteImport.update({
    id: "/support/",
    path: "/support/",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugSupportTicketIdRoute =
  DashboardDatasetSlugSupportTicketIdRouteImport.update({
    id: "/support/$ticketId",
    path: "/support/$ticketId",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugSupportNewRoute =
  DashboardDatasetSlugSupportNewRouteImport.update({
    id: "/support/new",
    path: "/support/new",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugTasksIndexRoute =
  DashboardDatasetSlugTasksIndexRouteImport.update({
    id: "/tasks/",
    path: "/tasks/",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugTasksTaskIdRoute =
  DashboardDatasetSlugTasksTaskIdRouteImport.update({
    id: "/tasks/$taskId",
    path: "/tasks/$taskId",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugTasksStatisticsRoute =
  DashboardDatasetSlugTasksStatisticsRouteImport.update({
    id: "/tasks/statistics",
    path: "/tasks/statistics",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugchatsChatsConversationIdRoute =
  DashboardDatasetSlugchatsChatsConversationIdRouteImport.update({
    id: "/$conversationId",
    path: "/$conversationId",
    getParentRoute: () => DashboardDatasetSlugchatsChatsRoute,
  } as any)
const DashboardDatasetSlugAppsInstalledIndexRoute =
  DashboardDatasetSlugAppsInstalledIndexRouteImport.update({
    id: "/installed/",
    path: "/installed/",
    getParentRoute: () => DashboardDatasetSlugAppsRoute,
  } as any)
const DashboardDatasetSlugAppsSyncsIndexRoute =
  DashboardDatasetSlugAppsSyncsIndexRouteImport.update({
    id: "/syncs/",
    path: "/syncs/",
    getParentRoute: () => DashboardDatasetSlugAppsRoute,
  } as any)
const DashboardDatasetSlugAppsSyncsSourceIdRoute =
  DashboardDatasetSlugAppsSyncsSourceIdRouteImport.update({
    id: "/syncs/$sourceId",
    path: "/syncs/$sourceId",
    getParentRoute: () => DashboardDatasetSlugAppsRoute,
  } as any)
const DashboardDatasetSlugAppsSyncsWritebacksRoute =
  DashboardDatasetSlugAppsSyncsWritebacksRouteImport.update({
    id: "/syncs/writebacks",
    path: "/syncs/writebacks",
    getParentRoute: () => DashboardDatasetSlugAppsRoute,
  } as any)
const DashboardDatasetSlugAppsInstalledAppIdRoute =
  DashboardDatasetSlugAppsInstalledAppIdRouteImport.update({
    id: "/apps_/installed/$appId",
    path: "/apps/installed/$appId",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugAutomationsAutomationIdIndexRoute =
  DashboardDatasetSlugAutomationsAutomationIdIndexRouteImport.update({
    id: "/automations/$automationId/",
    path: "/automations/$automationId/",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugAutomationsAutomationIdBuilderRoute =
  DashboardDatasetSlugAutomationsAutomationIdBuilderRouteImport.update({
    id: "/automations/$automationId/builder",
    path: "/automations/$automationId/builder",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugAutomationsAutomationIdLogsRoute =
  DashboardDatasetSlugAutomationsAutomationIdLogsRouteImport.update({
    id: "/automations/$automationId/logs",
    path: "/automations/$automationId/logs",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataApplicationsActivitiesRoute =
  DashboardDatasetSlugDataApplicationsActivitiesRouteImport.update({
    id: "/activities",
    path: "/activities",
    getParentRoute: () => DashboardDatasetSlugDataApplicationsRouteRoute,
  } as any)
const DashboardDatasetSlugDataApplicationsListRoute =
  DashboardDatasetSlugDataApplicationsListRouteImport.update({
    id: "/list",
    path: "/list",
    getParentRoute: () => DashboardDatasetSlugDataApplicationsRouteRoute,
  } as any)
const DashboardDatasetSlugDataCandidatesIndexRoute =
  DashboardDatasetSlugDataCandidatesIndexRouteImport.update({
    id: "/data/candidates/",
    path: "/data/candidates/",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataCandidatesCandidateIdRoute =
  DashboardDatasetSlugDataCandidatesCandidateIdRouteImport.update({
    id: "/data/candidates/$candidateId",
    path: "/data/candidates/$candidateId",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataCandidatesCreateRoute =
  DashboardDatasetSlugDataCandidatesCreateRouteImport.update({
    id: "/data/candidates/create",
    path: "/data/candidates/create",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataCandidatesSettingsRoute =
  DashboardDatasetSlugDataCandidatesSettingsRouteImport.update({
    id: "/data/candidates/settings",
    path: "/data/candidates/settings",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataClientsIndexRoute =
  DashboardDatasetSlugDataClientsIndexRouteImport.update({
    id: "/data/clients/",
    path: "/data/clients/",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataClientsClientIdRoute =
  DashboardDatasetSlugDataClientsClientIdRouteImport.update({
    id: "/data/clients/$clientId",
    path: "/data/clients/$clientId",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataClientsCreateRoute =
  DashboardDatasetSlugDataClientsCreateRouteImport.update({
    id: "/data/clients/create",
    path: "/data/clients/create",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataClientsSettingsRoute =
  DashboardDatasetSlugDataClientsSettingsRouteImport.update({
    id: "/data/clients/settings",
    path: "/data/clients/settings",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataContactsIndexRoute =
  DashboardDatasetSlugDataContactsIndexRouteImport.update({
    id: "/data/contacts/",
    path: "/data/contacts/",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataContactsContactIdRoute =
  DashboardDatasetSlugDataContactsContactIdRouteImport.update({
    id: "/data/contacts/$contactId",
    path: "/data/contacts/$contactId",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataContactsCreateRoute =
  DashboardDatasetSlugDataContactsCreateRouteImport.update({
    id: "/data/contacts/create",
    path: "/data/contacts/create",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataContactsSettingsRoute =
  DashboardDatasetSlugDataContactsSettingsRouteImport.update({
    id: "/data/contacts/settings",
    path: "/data/contacts/settings",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataCustomCreateRoute =
  DashboardDatasetSlugDataCustomCreateRouteImport.update({
    id: "/data/custom/create",
    path: "/data/custom/create",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataCvSendsIndexRoute =
  DashboardDatasetSlugDataCvSendsIndexRouteImport.update({
    id: "/data/cv-sends/",
    path: "/data/cv-sends/",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataJobSubmissionsIndexRoute =
  DashboardDatasetSlugDataJobSubmissionsIndexRouteImport.update({
    id: "/data/job-submissions/",
    path: "/data/job-submissions/",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataJobsIndexRoute =
  DashboardDatasetSlugDataJobsIndexRouteImport.update({
    id: "/data/jobs/",
    path: "/data/jobs/",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataJobsJobIdRoute =
  DashboardDatasetSlugDataJobsJobIdRouteImport.update({
    id: "/data/jobs/$jobId",
    path: "/data/jobs/$jobId",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataJobsCreateRoute =
  DashboardDatasetSlugDataJobsCreateRouteImport.update({
    id: "/data/jobs/create",
    path: "/data/jobs/create",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataJobsSettingsRoute =
  DashboardDatasetSlugDataJobsSettingsRouteImport.update({
    id: "/data/jobs/settings",
    path: "/data/jobs/settings",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataListsIndexRoute =
  DashboardDatasetSlugDataListsIndexRouteImport.update({
    id: "/data/lists/",
    path: "/data/lists/",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataListsListIdRoute =
  DashboardDatasetSlugDataListsListIdRouteImport.update({
    id: "/data/lists/$listId",
    path: "/data/lists/$listId",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataPlacementsIndexRoute =
  DashboardDatasetSlugDataPlacementsIndexRouteImport.update({
    id: "/data/placements/",
    path: "/data/placements/",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataPlacementsSettingsRoute =
  DashboardDatasetSlugDataPlacementsSettingsRouteImport.update({
    id: "/data/placements/settings",
    path: "/data/placements/settings",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataSkillsIndexRoute =
  DashboardDatasetSlugDataSkillsIndexRouteImport.update({
    id: "/data/skills/",
    path: "/data/skills/",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataSkillsSkillIdRoute =
  DashboardDatasetSlugDataSkillsSkillIdRouteImport.update({
    id: "/data/skills/$skillId",
    path: "/data/skills/$skillId",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataSkillsReviewRoute =
  DashboardDatasetSlugDataSkillsReviewRouteImport.update({
    id: "/data/skills/review",
    path: "/data/skills/review",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataSkillsSettingsRoute =
  DashboardDatasetSlugDataSkillsSettingsRouteImport.update({
    id: "/data/skills/settings",
    path: "/data/skills/settings",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugNotesIdEditRoute =
  DashboardDatasetSlugNotesIdEditRouteImport.update({
    id: "/notes/$id/edit",
    path: "/notes/$id/edit",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugSettingsAiAgentsIdRoute =
  DashboardDatasetSlugSettingsAiAgentsIdRouteImport.update({
    id: "/ai-agents_/$id",
    path: "/ai-agents/$id",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugSettingsAiAgentsCreateRoute =
  DashboardDatasetSlugSettingsAiAgentsCreateRouteImport.update({
    id: "/ai-agents_/create",
    path: "/ai-agents/create",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugSettingsEmailSettingsIndexRoute =
  DashboardDatasetSlugSettingsEmailSettingsIndexRouteImport.update({
    id: "/email-settings/",
    path: "/email-settings/",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugSettingsLinkedAccountsIndexRoute =
  DashboardDatasetSlugSettingsLinkedAccountsIndexRouteImport.update({
    id: "/linked-accounts/",
    path: "/linked-accounts/",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugSettingsLiveAgentsIdRoute =
  DashboardDatasetSlugSettingsLiveAgentsIdRouteImport.update({
    id: "/live-agents_/$id",
    path: "/live-agents/$id",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugSettingsLiveAgentsCreateRoute =
  DashboardDatasetSlugSettingsLiveAgentsCreateRouteImport.update({
    id: "/live-agents_/create",
    path: "/live-agents/create",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugSettingsPermissionsIndexRoute =
  DashboardDatasetSlugSettingsPermissionsIndexRouteImport.update({
    id: "/permissions/",
    path: "/permissions/",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugSettingsPermissionsCreateRoute =
  DashboardDatasetSlugSettingsPermissionsCreateRouteImport.update({
    id: "/permissions/create",
    path: "/permissions/create",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugSettingsTagsIdRoute =
  DashboardDatasetSlugSettingsTagsIdRouteImport.update({
    id: "/tags_/$id",
    path: "/tags/$id",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugAppsSyncsSourceIdSourceObjectIdRoute =
  DashboardDatasetSlugAppsSyncsSourceIdSourceObjectIdRouteImport.update({
    id: "/$sourceObjectId",
    path: "/$sourceObjectId",
    getParentRoute: () => DashboardDatasetSlugAppsSyncsSourceIdRoute,
  } as any)
const DashboardDatasetSlugAutomationsAutomationIdLogsJourneyIdRoute =
  DashboardDatasetSlugAutomationsAutomationIdLogsJourneyIdRouteImport.update({
    id: "/$journeyId",
    path: "/$journeyId",
    getParentRoute: () => DashboardDatasetSlugAutomationsAutomationIdLogsRoute,
  } as any)
const DashboardDatasetSlugDataApplicationsListApplicationIdRoute =
  DashboardDatasetSlugDataApplicationsListApplicationIdRouteImport.update({
    id: "/$applicationId",
    path: "/$applicationId",
    getParentRoute: () => DashboardDatasetSlugDataApplicationsListRoute,
  } as any)
const DashboardDatasetSlugDataApplicationsTableIndexRoute =
  DashboardDatasetSlugDataApplicationsTableIndexRouteImport.update({
    id: "/table/",
    path: "/table/",
    getParentRoute: () => DashboardDatasetSlugDataApplicationsRouteRoute,
  } as any)
const DashboardDatasetSlugDataApplicationsTableApplicationIdRoute =
  DashboardDatasetSlugDataApplicationsTableApplicationIdRouteImport.update({
    id: "/table/$applicationId",
    path: "/table/$applicationId",
    getParentRoute: () => DashboardDatasetSlugDataApplicationsRouteRoute,
  } as any)
const DashboardDatasetSlugDataCandidatesEditIdRoute =
  DashboardDatasetSlugDataCandidatesEditIdRouteImport.update({
    id: "/data/candidates/edit/$id",
    path: "/data/candidates/edit/$id",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataCandidatesViewViewNameRoute =
  DashboardDatasetSlugDataCandidatesViewViewNameRouteImport.update({
    id: "/data/candidates/view/$viewName",
    path: "/data/candidates/view/$viewName",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataClientsEditIdRoute =
  DashboardDatasetSlugDataClientsEditIdRouteImport.update({
    id: "/data/clients/edit/$id",
    path: "/data/clients/edit/$id",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataClientsViewViewNameRoute =
  DashboardDatasetSlugDataClientsViewViewNameRouteImport.update({
    id: "/data/clients/view/$viewName",
    path: "/data/clients/view/$viewName",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataContactsEditIdRoute =
  DashboardDatasetSlugDataContactsEditIdRouteImport.update({
    id: "/data/contacts/edit/$id",
    path: "/data/contacts/edit/$id",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataContactsViewViewNameRoute =
  DashboardDatasetSlugDataContactsViewViewNameRouteImport.update({
    id: "/data/contacts/view/$viewName",
    path: "/data/contacts/view/$viewName",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataJobsEditIdRoute =
  DashboardDatasetSlugDataJobsEditIdRouteImport.update({
    id: "/data/jobs/edit/$id",
    path: "/data/jobs/edit/$id",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataJobsViewViewNameRoute =
  DashboardDatasetSlugDataJobsViewViewNameRouteImport.update({
    id: "/data/jobs/view/$viewName",
    path: "/data/jobs/view/$viewName",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataSkillsSetsIndexRoute =
  DashboardDatasetSlugDataSkillsSetsIndexRouteImport.update({
    id: "/data/skills/sets/",
    path: "/data/skills/sets/",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataSkillsSetsSet_idRoute =
  DashboardDatasetSlugDataSkillsSetsSet_idRouteImport.update({
    id: "/data/skills/sets/$set_id",
    path: "/data/skills/sets/$set_id",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugSettingsEmailSettingsSyncSettingsIndexRoute =
  DashboardDatasetSlugSettingsEmailSettingsSyncSettingsIndexRouteImport.update({
    id: "/email-settings/sync-settings/",
    path: "/email-settings/sync-settings/",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugSettingsEmailSettingsTemplatesIndexRoute =
  DashboardDatasetSlugSettingsEmailSettingsTemplatesIndexRouteImport.update({
    id: "/email-settings/templates/",
    path: "/email-settings/templates/",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugSettingsEmailSettingsTemplatesCreateRoute =
  DashboardDatasetSlugSettingsEmailSettingsTemplatesCreateRouteImport.update({
    id: "/email-settings/templates/create",
    path: "/email-settings/templates/create",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugSettingsLiveAgentsIdIndexRoute =
  DashboardDatasetSlugSettingsLiveAgentsIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashboardDatasetSlugSettingsLiveAgentsIdRoute,
  } as any)
const DashboardDatasetSlugSettingsLiveAgentsIdEditRoute =
  DashboardDatasetSlugSettingsLiveAgentsIdEditRouteImport.update({
    id: "/edit",
    path: "/edit",
    getParentRoute: () => DashboardDatasetSlugSettingsLiveAgentsIdRoute,
  } as any)
const DashboardDatasetSlugSettingsLiveAgentsIdRunsRoute =
  DashboardDatasetSlugSettingsLiveAgentsIdRunsRouteImport.update({
    id: "/runs",
    path: "/runs",
    getParentRoute: () => DashboardDatasetSlugSettingsLiveAgentsIdRoute,
  } as any)
const DashboardDatasetSlugSettingsPermissionsEditIdRoute =
  DashboardDatasetSlugSettingsPermissionsEditIdRouteImport.update({
    id: "/permissions/edit/$id",
    path: "/permissions/edit/$id",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugSettingsUsersIdEditRoute =
  DashboardDatasetSlugSettingsUsersIdEditRouteImport.update({
    id: "/$id/edit",
    path: "/$id/edit",
    getParentRoute: () => DashboardDatasetSlugSettingsUsersRoute,
  } as any)
const DashboardDatasetSlugchatsChatsConversationIdSearchesSearchIdRoute =
  DashboardDatasetSlugchatsChatsConversationIdSearchesSearchIdRouteImport.update(
    {
      id: "/(chats)/chats_/$conversationId/searches/$searchId",
      path: "/chats/$conversationId/searches/$searchId",
      getParentRoute: () => DashboardDatasetSlugRoute,
    } as any,
  )
const DashboardDatasetSlugDataCustomDetailsIdCreateRoute =
  DashboardDatasetSlugDataCustomDetailsIdCreateRouteImport.update({
    id: "/data/custom/details/$id/create",
    path: "/data/custom/details/$id/create",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataCustomDetailsIdKanbanRoute =
  DashboardDatasetSlugDataCustomDetailsIdKanbanRouteImport.update({
    id: "/data/custom/details/$id/kanban",
    path: "/data/custom/details/$id/kanban",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataCustomDetailsIdSettingsRoute =
  DashboardDatasetSlugDataCustomDetailsIdSettingsRouteImport.update({
    id: "/data/custom/details/$id/settings",
    path: "/data/custom/details/$id/settings",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugSettingsEmailSettingsTemplatesEditIdRoute =
  DashboardDatasetSlugSettingsEmailSettingsTemplatesEditIdRouteImport.update({
    id: "/email-settings/templates/edit/$id",
    path: "/email-settings/templates/edit/$id",
    getParentRoute: () => DashboardDatasetSlugSettingsRouteRoute,
  } as any)
const DashboardDatasetSlugSettingsLiveAgentsIdRunsIndexRoute =
  DashboardDatasetSlugSettingsLiveAgentsIdRunsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashboardDatasetSlugSettingsLiveAgentsIdRunsRoute,
  } as any)
const DashboardDatasetSlugSettingsLiveAgentsIdRunsRunIdRoute =
  DashboardDatasetSlugSettingsLiveAgentsIdRunsRunIdRouteImport.update({
    id: "/$runId",
    path: "/$runId",
    getParentRoute: () => DashboardDatasetSlugSettingsLiveAgentsIdRunsRoute,
  } as any)
const DashboardDatasetSlugDataCustomDetailsIdEditRowIdRoute =
  DashboardDatasetSlugDataCustomDetailsIdEditRowIdRouteImport.update({
    id: "/data/custom/details/$id/edit/$rowId",
    path: "/data/custom/details/$id/edit/$rowId",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataCustomDetailsIdTableIndexRoute =
  DashboardDatasetSlugDataCustomDetailsIdTableIndexRouteImport.update({
    id: "/data/custom/details/$id/table/",
    path: "/data/custom/details/$id/table/",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)
const DashboardDatasetSlugDataCustomDetailsIdTableCustomDetailsIdRoute =
  DashboardDatasetSlugDataCustomDetailsIdTableCustomDetailsIdRouteImport.update(
    {
      id: "/data/custom/details/$id/table/$customDetailsId",
      path: "/data/custom/details/$id/table/$customDetailsId",
      getParentRoute: () => DashboardDatasetSlugRoute,
    } as any,
  )
const DashboardDatasetSlugDataCustomDetailsIdViewViewNameRoute =
  DashboardDatasetSlugDataCustomDetailsIdViewViewNameRouteImport.update({
    id: "/data/custom/details/$id/view/$viewName",
    path: "/data/custom/details/$id/view/$viewName",
    getParentRoute: () => DashboardDatasetSlugRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/404": typeof R404Route
  "/$datasetSlug": typeof DashboardDatasetSlugRouteWithChildren
  "/login": typeof PublicLoginRoute
  "/magic-link-sent": typeof PublicMagicLinkSentRoute
  "/mfa": typeof PublicMfaRoute
  "/openapi-oauth": typeof PublicOpenapiOauthRoute
  "/select-dataset": typeof PublicSelectDatasetRoute
  "/verify": typeof PublicVerifyRoute
  "/verify-user-dataset": typeof PublicVerifyUserDatasetRoute
  "/$datasetSlug/settings": typeof DashboardDatasetSlugSettingsRouteRouteWithChildren
  "/$datasetSlug/apps": typeof DashboardDatasetSlugAppsRouteWithChildren
  "/$datasetSlug/compliance": typeof DashboardDatasetSlugComplianceRoute
  "/$datasetSlug/dashboard": typeof DashboardDatasetSlugDashboardRoute
  "/$datasetSlug/profile": typeof DashboardDatasetSlugProfileRoute
  "/$datasetSlug/search": typeof DashboardDatasetSlugSearchRouteWithChildren
  "/oauth/response": typeof OauthOauthResponseRoute
  "/oauth/verify-link-account-request": typeof OauthOauthVerifyLinkAccountRequestRoute
  "/oauth/verify-new-account-request": typeof OauthOauthVerifyNewAccountRequestRoute
  "/oauth/verify-new-user-signup": typeof OauthOauthVerifyNewUserSignupRoute
  "/$datasetSlug/data/applications": typeof DashboardDatasetSlugDataApplicationsRouteRouteWithChildren
  "/$datasetSlug/chats": typeof DashboardDatasetSlugchatsChatsRouteWithChildren
  "/$datasetSlug/apps/$slug": typeof DashboardDatasetSlugAppsSlugRoute
  "/$datasetSlug/automations/new_automation": typeof DashboardDatasetSlugAutomationsNew_automationRoute
  "/$datasetSlug/custom-ui/$id": typeof DashboardDatasetSlugCustomUiIdRoute
  "/$datasetSlug/docs/$": typeof DashboardDatasetSlugDocsSplatRoute
  "/$datasetSlug/notes/create": typeof DashboardDatasetSlugNotesCreateRoute
  "/$datasetSlug/plugins/$id": typeof DashboardDatasetSlugPluginsIdRoute
  "/$datasetSlug/search/$entityType": typeof DashboardDatasetSlugSearchEntityTypeRoute
  "/$datasetSlug/settings/ai-agents": typeof DashboardDatasetSlugSettingsAiAgentsRoute
  "/$datasetSlug/settings/ai-skills": typeof DashboardDatasetSlugSettingsAiSkillsRoute
  "/$datasetSlug/settings/api": typeof DashboardDatasetSlugSettingsApiRoute
  "/$datasetSlug/settings/applications": typeof DashboardDatasetSlugSettingsApplicationsRoute
  "/$datasetSlug/settings/custom-ui": typeof DashboardDatasetSlugSettingsCustomUiRoute
  "/$datasetSlug/settings/files": typeof DashboardDatasetSlugSettingsFilesRoute
  "/$datasetSlug/settings/global-ai-settings": typeof DashboardDatasetSlugSettingsGlobalAiSettingsRoute
  "/$datasetSlug/settings/interviews": typeof DashboardDatasetSlugSettingsInterviewsRoute
  "/$datasetSlug/settings/live-agents": typeof DashboardDatasetSlugSettingsLiveAgentsRoute
  "/$datasetSlug/settings/plugins": typeof DashboardDatasetSlugSettingsPluginsRoute
  "/$datasetSlug/settings/security": typeof DashboardDatasetSlugSettingsSecurityRoute
  "/$datasetSlug/settings/submissions": typeof DashboardDatasetSlugSettingsSubmissionsRoute
  "/$datasetSlug/settings/tags": typeof DashboardDatasetSlugSettingsTagsRoute
  "/$datasetSlug/settings/users": typeof DashboardDatasetSlugSettingsUsersRouteWithChildren
  "/$datasetSlug/support/$ticketId": typeof DashboardDatasetSlugSupportTicketIdRoute
  "/$datasetSlug/support/new": typeof DashboardDatasetSlugSupportNewRoute
  "/$datasetSlug/tasks/$taskId": typeof DashboardDatasetSlugTasksTaskIdRoute
  "/$datasetSlug/tasks/statistics": typeof DashboardDatasetSlugTasksStatisticsRoute
  "/$datasetSlug/apps/": typeof DashboardDatasetSlugAppsIndexRoute
  "/$datasetSlug/automations/": typeof DashboardDatasetSlugAutomationsIndexRoute
  "/$datasetSlug/docs/": typeof DashboardDatasetSlugDocsIndexRoute
  "/$datasetSlug/library/": typeof DashboardDatasetSlugLibraryIndexRoute
  "/$datasetSlug/notes/": typeof DashboardDatasetSlugNotesIndexRoute
  "/$datasetSlug/support/": typeof DashboardDatasetSlugSupportIndexRoute
  "/$datasetSlug/tasks/": typeof DashboardDatasetSlugTasksIndexRoute
  "/$datasetSlug/chats/$conversationId": typeof DashboardDatasetSlugchatsChatsConversationIdRoute
  "/$datasetSlug/apps/syncs/$sourceId": typeof DashboardDatasetSlugAppsSyncsSourceIdRouteWithChildren
  "/$datasetSlug/apps/syncs/writebacks": typeof DashboardDatasetSlugAppsSyncsWritebacksRoute
  "/$datasetSlug/apps/installed/$appId": typeof DashboardDatasetSlugAppsInstalledAppIdRoute
  "/$datasetSlug/automations/$automationId/builder": typeof DashboardDatasetSlugAutomationsAutomationIdBuilderRoute
  "/$datasetSlug/automations/$automationId/logs": typeof DashboardDatasetSlugAutomationsAutomationIdLogsRouteWithChildren
  "/$datasetSlug/data/applications/activities": typeof DashboardDatasetSlugDataApplicationsActivitiesRoute
  "/$datasetSlug/data/applications/list": typeof DashboardDatasetSlugDataApplicationsListRouteWithChildren
  "/$datasetSlug/data/candidates/$candidateId": typeof DashboardDatasetSlugDataCandidatesCandidateIdRoute
  "/$datasetSlug/data/candidates/create": typeof DashboardDatasetSlugDataCandidatesCreateRoute
  "/$datasetSlug/data/candidates/settings": typeof DashboardDatasetSlugDataCandidatesSettingsRoute
  "/$datasetSlug/data/clients/$clientId": typeof DashboardDatasetSlugDataClientsClientIdRoute
  "/$datasetSlug/data/clients/create": typeof DashboardDatasetSlugDataClientsCreateRoute
  "/$datasetSlug/data/clients/settings": typeof DashboardDatasetSlugDataClientsSettingsRoute
  "/$datasetSlug/data/contacts/$contactId": typeof DashboardDatasetSlugDataContactsContactIdRoute
  "/$datasetSlug/data/contacts/create": typeof DashboardDatasetSlugDataContactsCreateRoute
  "/$datasetSlug/data/contacts/settings": typeof DashboardDatasetSlugDataContactsSettingsRoute
  "/$datasetSlug/data/custom/create": typeof DashboardDatasetSlugDataCustomCreateRoute
  "/$datasetSlug/data/jobs/$jobId": typeof DashboardDatasetSlugDataJobsJobIdRoute
  "/$datasetSlug/data/jobs/create": typeof DashboardDatasetSlugDataJobsCreateRoute
  "/$datasetSlug/data/jobs/settings": typeof DashboardDatasetSlugDataJobsSettingsRoute
  "/$datasetSlug/data/lists/$listId": typeof DashboardDatasetSlugDataListsListIdRoute
  "/$datasetSlug/data/placements/settings": typeof DashboardDatasetSlugDataPlacementsSettingsRoute
  "/$datasetSlug/data/skills/$skillId": typeof DashboardDatasetSlugDataSkillsSkillIdRoute
  "/$datasetSlug/data/skills/review": typeof DashboardDatasetSlugDataSkillsReviewRoute
  "/$datasetSlug/data/skills/settings": typeof DashboardDatasetSlugDataSkillsSettingsRoute
  "/$datasetSlug/notes/$id/edit": typeof DashboardDatasetSlugNotesIdEditRoute
  "/$datasetSlug/settings/ai-agents/$id": typeof DashboardDatasetSlugSettingsAiAgentsIdRoute
  "/$datasetSlug/settings/ai-agents/create": typeof DashboardDatasetSlugSettingsAiAgentsCreateRoute
  "/$datasetSlug/settings/live-agents/$id": typeof DashboardDatasetSlugSettingsLiveAgentsIdRouteWithChildren
  "/$datasetSlug/settings/live-agents/create": typeof DashboardDatasetSlugSettingsLiveAgentsCreateRoute
  "/$datasetSlug/settings/permissions/create": typeof DashboardDatasetSlugSettingsPermissionsCreateRoute
  "/$datasetSlug/settings/tags/$id": typeof DashboardDatasetSlugSettingsTagsIdRoute
  "/$datasetSlug/apps/installed/": typeof DashboardDatasetSlugAppsInstalledIndexRoute
  "/$datasetSlug/apps/syncs/": typeof DashboardDatasetSlugAppsSyncsIndexRoute
  "/$datasetSlug/automations/$automationId/": typeof DashboardDatasetSlugAutomationsAutomationIdIndexRoute
  "/$datasetSlug/data/candidates/": typeof DashboardDatasetSlugDataCandidatesIndexRoute
  "/$datasetSlug/data/clients/": typeof DashboardDatasetSlugDataClientsIndexRoute
  "/$datasetSlug/data/contacts/": typeof DashboardDatasetSlugDataContactsIndexRoute
  "/$datasetSlug/data/cv-sends/": typeof DashboardDatasetSlugDataCvSendsIndexRoute
  "/$datasetSlug/data/job-submissions/": typeof DashboardDatasetSlugDataJobSubmissionsIndexRoute
  "/$datasetSlug/data/jobs/": typeof DashboardDatasetSlugDataJobsIndexRoute
  "/$datasetSlug/data/lists/": typeof DashboardDatasetSlugDataListsIndexRoute
  "/$datasetSlug/data/placements/": typeof DashboardDatasetSlugDataPlacementsIndexRoute
  "/$datasetSlug/data/skills/": typeof DashboardDatasetSlugDataSkillsIndexRoute
  "/$datasetSlug/settings/email-settings/": typeof DashboardDatasetSlugSettingsEmailSettingsIndexRoute
  "/$datasetSlug/settings/linked-accounts/": typeof DashboardDatasetSlugSettingsLinkedAccountsIndexRoute
  "/$datasetSlug/settings/permissions/": typeof DashboardDatasetSlugSettingsPermissionsIndexRoute
  "/$datasetSlug/apps/syncs/$sourceId/$sourceObjectId": typeof DashboardDatasetSlugAppsSyncsSourceIdSourceObjectIdRoute
  "/$datasetSlug/automations/$automationId/logs/$journeyId": typeof DashboardDatasetSlugAutomationsAutomationIdLogsJourneyIdRoute
  "/$datasetSlug/data/applications/list/$applicationId": typeof DashboardDatasetSlugDataApplicationsListApplicationIdRoute
  "/$datasetSlug/data/applications/table/$applicationId": typeof DashboardDatasetSlugDataApplicationsTableApplicationIdRoute
  "/$datasetSlug/data/candidates/edit/$id": typeof DashboardDatasetSlugDataCandidatesEditIdRoute
  "/$datasetSlug/data/candidates/view/$viewName": typeof DashboardDatasetSlugDataCandidatesViewViewNameRoute
  "/$datasetSlug/data/clients/edit/$id": typeof DashboardDatasetSlugDataClientsEditIdRoute
  "/$datasetSlug/data/clients/view/$viewName": typeof DashboardDatasetSlugDataClientsViewViewNameRoute
  "/$datasetSlug/data/contacts/edit/$id": typeof DashboardDatasetSlugDataContactsEditIdRoute
  "/$datasetSlug/data/contacts/view/$viewName": typeof DashboardDatasetSlugDataContactsViewViewNameRoute
  "/$datasetSlug/data/jobs/edit/$id": typeof DashboardDatasetSlugDataJobsEditIdRoute
  "/$datasetSlug/data/jobs/view/$viewName": typeof DashboardDatasetSlugDataJobsViewViewNameRoute
  "/$datasetSlug/data/skills/sets/$set_id": typeof DashboardDatasetSlugDataSkillsSetsSet_idRoute
  "/$datasetSlug/settings/email-settings/templates/create": typeof DashboardDatasetSlugSettingsEmailSettingsTemplatesCreateRoute
  "/$datasetSlug/settings/live-agents/$id/edit": typeof DashboardDatasetSlugSettingsLiveAgentsIdEditRoute
  "/$datasetSlug/settings/live-agents/$id/runs": typeof DashboardDatasetSlugSettingsLiveAgentsIdRunsRouteWithChildren
  "/$datasetSlug/settings/permissions/edit/$id": typeof DashboardDatasetSlugSettingsPermissionsEditIdRoute
  "/$datasetSlug/settings/users/$id/edit": typeof DashboardDatasetSlugSettingsUsersIdEditRoute
  "/$datasetSlug/data/applications/table/": typeof DashboardDatasetSlugDataApplicationsTableIndexRoute
  "/$datasetSlug/data/skills/sets/": typeof DashboardDatasetSlugDataSkillsSetsIndexRoute
  "/$datasetSlug/settings/email-settings/sync-settings/": typeof DashboardDatasetSlugSettingsEmailSettingsSyncSettingsIndexRoute
  "/$datasetSlug/settings/email-settings/templates/": typeof DashboardDatasetSlugSettingsEmailSettingsTemplatesIndexRoute
  "/$datasetSlug/settings/live-agents/$id/": typeof DashboardDatasetSlugSettingsLiveAgentsIdIndexRoute
  "/$datasetSlug/chats/$conversationId/searches/$searchId": typeof DashboardDatasetSlugchatsChatsConversationIdSearchesSearchIdRoute
  "/$datasetSlug/data/custom/details/$id/create": typeof DashboardDatasetSlugDataCustomDetailsIdCreateRoute
  "/$datasetSlug/data/custom/details/$id/kanban": typeof DashboardDatasetSlugDataCustomDetailsIdKanbanRoute
  "/$datasetSlug/data/custom/details/$id/settings": typeof DashboardDatasetSlugDataCustomDetailsIdSettingsRoute
  "/$datasetSlug/settings/email-settings/templates/edit/$id": typeof DashboardDatasetSlugSettingsEmailSettingsTemplatesEditIdRoute
  "/$datasetSlug/settings/live-agents/$id/runs/$runId": typeof DashboardDatasetSlugSettingsLiveAgentsIdRunsRunIdRoute
  "/$datasetSlug/settings/live-agents/$id/runs/": typeof DashboardDatasetSlugSettingsLiveAgentsIdRunsIndexRoute
  "/$datasetSlug/data/custom/details/$id/edit/$rowId": typeof DashboardDatasetSlugDataCustomDetailsIdEditRowIdRoute
  "/$datasetSlug/data/custom/details/$id/table/$customDetailsId": typeof DashboardDatasetSlugDataCustomDetailsIdTableCustomDetailsIdRoute
  "/$datasetSlug/data/custom/details/$id/view/$viewName": typeof DashboardDatasetSlugDataCustomDetailsIdViewViewNameRoute
  "/$datasetSlug/data/custom/details/$id/table/": typeof DashboardDatasetSlugDataCustomDetailsIdTableIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/404": typeof R404Route
  "/$datasetSlug": typeof DashboardDatasetSlugRouteWithChildren
  "/login": typeof PublicLoginRoute
  "/magic-link-sent": typeof PublicMagicLinkSentRoute
  "/mfa": typeof PublicMfaRoute
  "/openapi-oauth": typeof PublicOpenapiOauthRoute
  "/select-dataset": typeof PublicSelectDatasetRoute
  "/verify": typeof PublicVerifyRoute
  "/verify-user-dataset": typeof PublicVerifyUserDatasetRoute
  "/$datasetSlug/settings": typeof DashboardDatasetSlugSettingsRouteRouteWithChildren
  "/$datasetSlug/compliance": typeof DashboardDatasetSlugComplianceRoute
  "/$datasetSlug/dashboard": typeof DashboardDatasetSlugDashboardRoute
  "/$datasetSlug/profile": typeof DashboardDatasetSlugProfileRoute
  "/$datasetSlug/search": typeof DashboardDatasetSlugSearchRouteWithChildren
  "/oauth/response": typeof OauthOauthResponseRoute
  "/oauth/verify-link-account-request": typeof OauthOauthVerifyLinkAccountRequestRoute
  "/oauth/verify-new-account-request": typeof OauthOauthVerifyNewAccountRequestRoute
  "/oauth/verify-new-user-signup": typeof OauthOauthVerifyNewUserSignupRoute
  "/$datasetSlug/data/applications": typeof DashboardDatasetSlugDataApplicationsRouteRouteWithChildren
  "/$datasetSlug/chats": typeof DashboardDatasetSlugchatsChatsRouteWithChildren
  "/$datasetSlug/apps/$slug": typeof DashboardDatasetSlugAppsSlugRoute
  "/$datasetSlug/automations/new_automation": typeof DashboardDatasetSlugAutomationsNew_automationRoute
  "/$datasetSlug/custom-ui/$id": typeof DashboardDatasetSlugCustomUiIdRoute
  "/$datasetSlug/docs/$": typeof DashboardDatasetSlugDocsSplatRoute
  "/$datasetSlug/notes/create": typeof DashboardDatasetSlugNotesCreateRoute
  "/$datasetSlug/plugins/$id": typeof DashboardDatasetSlugPluginsIdRoute
  "/$datasetSlug/search/$entityType": typeof DashboardDatasetSlugSearchEntityTypeRoute
  "/$datasetSlug/settings/ai-agents": typeof DashboardDatasetSlugSettingsAiAgentsRoute
  "/$datasetSlug/settings/ai-skills": typeof DashboardDatasetSlugSettingsAiSkillsRoute
  "/$datasetSlug/settings/api": typeof DashboardDatasetSlugSettingsApiRoute
  "/$datasetSlug/settings/applications": typeof DashboardDatasetSlugSettingsApplicationsRoute
  "/$datasetSlug/settings/custom-ui": typeof DashboardDatasetSlugSettingsCustomUiRoute
  "/$datasetSlug/settings/files": typeof DashboardDatasetSlugSettingsFilesRoute
  "/$datasetSlug/settings/global-ai-settings": typeof DashboardDatasetSlugSettingsGlobalAiSettingsRoute
  "/$datasetSlug/settings/interviews": typeof DashboardDatasetSlugSettingsInterviewsRoute
  "/$datasetSlug/settings/live-agents": typeof DashboardDatasetSlugSettingsLiveAgentsRoute
  "/$datasetSlug/settings/plugins": typeof DashboardDatasetSlugSettingsPluginsRoute
  "/$datasetSlug/settings/security": typeof DashboardDatasetSlugSettingsSecurityRoute
  "/$datasetSlug/settings/submissions": typeof DashboardDatasetSlugSettingsSubmissionsRoute
  "/$datasetSlug/settings/tags": typeof DashboardDatasetSlugSettingsTagsRoute
  "/$datasetSlug/settings/users": typeof DashboardDatasetSlugSettingsUsersRouteWithChildren
  "/$datasetSlug/support/$ticketId": typeof DashboardDatasetSlugSupportTicketIdRoute
  "/$datasetSlug/support/new": typeof DashboardDatasetSlugSupportNewRoute
  "/$datasetSlug/tasks/$taskId": typeof DashboardDatasetSlugTasksTaskIdRoute
  "/$datasetSlug/tasks/statistics": typeof DashboardDatasetSlugTasksStatisticsRoute
  "/$datasetSlug/apps": typeof DashboardDatasetSlugAppsIndexRoute
  "/$datasetSlug/automations": typeof DashboardDatasetSlugAutomationsIndexRoute
  "/$datasetSlug/docs": typeof DashboardDatasetSlugDocsIndexRoute
  "/$datasetSlug/library": typeof DashboardDatasetSlugLibraryIndexRoute
  "/$datasetSlug/notes": typeof DashboardDatasetSlugNotesIndexRoute
  "/$datasetSlug/support": typeof DashboardDatasetSlugSupportIndexRoute
  "/$datasetSlug/tasks": typeof DashboardDatasetSlugTasksIndexRoute
  "/$datasetSlug/chats/$conversationId": typeof DashboardDatasetSlugchatsChatsConversationIdRoute
  "/$datasetSlug/apps/syncs/$sourceId": typeof DashboardDatasetSlugAppsSyncsSourceIdRouteWithChildren
  "/$datasetSlug/apps/syncs/writebacks": typeof DashboardDatasetSlugAppsSyncsWritebacksRoute
  "/$datasetSlug/apps/installed/$appId": typeof DashboardDatasetSlugAppsInstalledAppIdRoute
  "/$datasetSlug/automations/$automationId/builder": typeof DashboardDatasetSlugAutomationsAutomationIdBuilderRoute
  "/$datasetSlug/automations/$automationId/logs": typeof DashboardDatasetSlugAutomationsAutomationIdLogsRouteWithChildren
  "/$datasetSlug/data/applications/activities": typeof DashboardDatasetSlugDataApplicationsActivitiesRoute
  "/$datasetSlug/data/applications/list": typeof DashboardDatasetSlugDataApplicationsListRouteWithChildren
  "/$datasetSlug/data/candidates/$candidateId": typeof DashboardDatasetSlugDataCandidatesCandidateIdRoute
  "/$datasetSlug/data/candidates/create": typeof DashboardDatasetSlugDataCandidatesCreateRoute
  "/$datasetSlug/data/candidates/settings": typeof DashboardDatasetSlugDataCandidatesSettingsRoute
  "/$datasetSlug/data/clients/$clientId": typeof DashboardDatasetSlugDataClientsClientIdRoute
  "/$datasetSlug/data/clients/create": typeof DashboardDatasetSlugDataClientsCreateRoute
  "/$datasetSlug/data/clients/settings": typeof DashboardDatasetSlugDataClientsSettingsRoute
  "/$datasetSlug/data/contacts/$contactId": typeof DashboardDatasetSlugDataContactsContactIdRoute
  "/$datasetSlug/data/contacts/create": typeof DashboardDatasetSlugDataContactsCreateRoute
  "/$datasetSlug/data/contacts/settings": typeof DashboardDatasetSlugDataContactsSettingsRoute
  "/$datasetSlug/data/custom/create": typeof DashboardDatasetSlugDataCustomCreateRoute
  "/$datasetSlug/data/jobs/$jobId": typeof DashboardDatasetSlugDataJobsJobIdRoute
  "/$datasetSlug/data/jobs/create": typeof DashboardDatasetSlugDataJobsCreateRoute
  "/$datasetSlug/data/jobs/settings": typeof DashboardDatasetSlugDataJobsSettingsRoute
  "/$datasetSlug/data/lists/$listId": typeof DashboardDatasetSlugDataListsListIdRoute
  "/$datasetSlug/data/placements/settings": typeof DashboardDatasetSlugDataPlacementsSettingsRoute
  "/$datasetSlug/data/skills/$skillId": typeof DashboardDatasetSlugDataSkillsSkillIdRoute
  "/$datasetSlug/data/skills/review": typeof DashboardDatasetSlugDataSkillsReviewRoute
  "/$datasetSlug/data/skills/settings": typeof DashboardDatasetSlugDataSkillsSettingsRoute
  "/$datasetSlug/notes/$id/edit": typeof DashboardDatasetSlugNotesIdEditRoute
  "/$datasetSlug/settings/ai-agents/$id": typeof DashboardDatasetSlugSettingsAiAgentsIdRoute
  "/$datasetSlug/settings/ai-agents/create": typeof DashboardDatasetSlugSettingsAiAgentsCreateRoute
  "/$datasetSlug/settings/live-agents/create": typeof DashboardDatasetSlugSettingsLiveAgentsCreateRoute
  "/$datasetSlug/settings/permissions/create": typeof DashboardDatasetSlugSettingsPermissionsCreateRoute
  "/$datasetSlug/settings/tags/$id": typeof DashboardDatasetSlugSettingsTagsIdRoute
  "/$datasetSlug/apps/installed": typeof DashboardDatasetSlugAppsInstalledIndexRoute
  "/$datasetSlug/apps/syncs": typeof DashboardDatasetSlugAppsSyncsIndexRoute
  "/$datasetSlug/automations/$automationId": typeof DashboardDatasetSlugAutomationsAutomationIdIndexRoute
  "/$datasetSlug/data/candidates": typeof DashboardDatasetSlugDataCandidatesIndexRoute
  "/$datasetSlug/data/clients": typeof DashboardDatasetSlugDataClientsIndexRoute
  "/$datasetSlug/data/contacts": typeof DashboardDatasetSlugDataContactsIndexRoute
  "/$datasetSlug/data/cv-sends": typeof DashboardDatasetSlugDataCvSendsIndexRoute
  "/$datasetSlug/data/job-submissions": typeof DashboardDatasetSlugDataJobSubmissionsIndexRoute
  "/$datasetSlug/data/jobs": typeof DashboardDatasetSlugDataJobsIndexRoute
  "/$datasetSlug/data/lists": typeof DashboardDatasetSlugDataListsIndexRoute
  "/$datasetSlug/data/placements": typeof DashboardDatasetSlugDataPlacementsIndexRoute
  "/$datasetSlug/data/skills": typeof DashboardDatasetSlugDataSkillsIndexRoute
  "/$datasetSlug/settings/email-settings": typeof DashboardDatasetSlugSettingsEmailSettingsIndexRoute
  "/$datasetSlug/settings/linked-accounts": typeof DashboardDatasetSlugSettingsLinkedAccountsIndexRoute
  "/$datasetSlug/settings/permissions": typeof DashboardDatasetSlugSettingsPermissionsIndexRoute
  "/$datasetSlug/apps/syncs/$sourceId/$sourceObjectId": typeof DashboardDatasetSlugAppsSyncsSourceIdSourceObjectIdRoute
  "/$datasetSlug/automations/$automationId/logs/$journeyId": typeof DashboardDatasetSlugAutomationsAutomationIdLogsJourneyIdRoute
  "/$datasetSlug/data/applications/list/$applicationId": typeof DashboardDatasetSlugDataApplicationsListApplicationIdRoute
  "/$datasetSlug/data/applications/table/$applicationId": typeof DashboardDatasetSlugDataApplicationsTableApplicationIdRoute
  "/$datasetSlug/data/candidates/edit/$id": typeof DashboardDatasetSlugDataCandidatesEditIdRoute
  "/$datasetSlug/data/candidates/view/$viewName": typeof DashboardDatasetSlugDataCandidatesViewViewNameRoute
  "/$datasetSlug/data/clients/edit/$id": typeof DashboardDatasetSlugDataClientsEditIdRoute
  "/$datasetSlug/data/clients/view/$viewName": typeof DashboardDatasetSlugDataClientsViewViewNameRoute
  "/$datasetSlug/data/contacts/edit/$id": typeof DashboardDatasetSlugDataContactsEditIdRoute
  "/$datasetSlug/data/contacts/view/$viewName": typeof DashboardDatasetSlugDataContactsViewViewNameRoute
  "/$datasetSlug/data/jobs/edit/$id": typeof DashboardDatasetSlugDataJobsEditIdRoute
  "/$datasetSlug/data/jobs/view/$viewName": typeof DashboardDatasetSlugDataJobsViewViewNameRoute
  "/$datasetSlug/data/skills/sets/$set_id": typeof DashboardDatasetSlugDataSkillsSetsSet_idRoute
  "/$datasetSlug/settings/email-settings/templates/create": typeof DashboardDatasetSlugSettingsEmailSettingsTemplatesCreateRoute
  "/$datasetSlug/settings/live-agents/$id/edit": typeof DashboardDatasetSlugSettingsLiveAgentsIdEditRoute
  "/$datasetSlug/settings/permissions/edit/$id": typeof DashboardDatasetSlugSettingsPermissionsEditIdRoute
  "/$datasetSlug/settings/users/$id/edit": typeof DashboardDatasetSlugSettingsUsersIdEditRoute
  "/$datasetSlug/data/applications/table": typeof DashboardDatasetSlugDataApplicationsTableIndexRoute
  "/$datasetSlug/data/skills/sets": typeof DashboardDatasetSlugDataSkillsSetsIndexRoute
  "/$datasetSlug/settings/email-settings/sync-settings": typeof DashboardDatasetSlugSettingsEmailSettingsSyncSettingsIndexRoute
  "/$datasetSlug/settings/email-settings/templates": typeof DashboardDatasetSlugSettingsEmailSettingsTemplatesIndexRoute
  "/$datasetSlug/settings/live-agents/$id": typeof DashboardDatasetSlugSettingsLiveAgentsIdIndexRoute
  "/$datasetSlug/chats/$conversationId/searches/$searchId": typeof DashboardDatasetSlugchatsChatsConversationIdSearchesSearchIdRoute
  "/$datasetSlug/data/custom/details/$id/create": typeof DashboardDatasetSlugDataCustomDetailsIdCreateRoute
  "/$datasetSlug/data/custom/details/$id/kanban": typeof DashboardDatasetSlugDataCustomDetailsIdKanbanRoute
  "/$datasetSlug/data/custom/details/$id/settings": typeof DashboardDatasetSlugDataCustomDetailsIdSettingsRoute
  "/$datasetSlug/settings/email-settings/templates/edit/$id": typeof DashboardDatasetSlugSettingsEmailSettingsTemplatesEditIdRoute
  "/$datasetSlug/settings/live-agents/$id/runs/$runId": typeof DashboardDatasetSlugSettingsLiveAgentsIdRunsRunIdRoute
  "/$datasetSlug/settings/live-agents/$id/runs": typeof DashboardDatasetSlugSettingsLiveAgentsIdRunsIndexRoute
  "/$datasetSlug/data/custom/details/$id/edit/$rowId": typeof DashboardDatasetSlugDataCustomDetailsIdEditRowIdRoute
  "/$datasetSlug/data/custom/details/$id/table/$customDetailsId": typeof DashboardDatasetSlugDataCustomDetailsIdTableCustomDetailsIdRoute
  "/$datasetSlug/data/custom/details/$id/view/$viewName": typeof DashboardDatasetSlugDataCustomDetailsIdViewViewNameRoute
  "/$datasetSlug/data/custom/details/$id/table": typeof DashboardDatasetSlugDataCustomDetailsIdTableIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/404": typeof R404Route
  "/_dashboard": typeof DashboardRouteWithChildren
  "/_oauth": typeof OauthRouteWithChildren
  "/_public": typeof PublicRouteWithChildren
  "/_dashboard/$datasetSlug": typeof DashboardDatasetSlugRouteWithChildren
  "/_public/login": typeof PublicLoginRoute
  "/_public/magic-link-sent": typeof PublicMagicLinkSentRoute
  "/_public/mfa": typeof PublicMfaRoute
  "/_public/openapi-oauth": typeof PublicOpenapiOauthRoute
  "/_public/select-dataset": typeof PublicSelectDatasetRoute
  "/_public/verify": typeof PublicVerifyRoute
  "/_public/verify-user-dataset": typeof PublicVerifyUserDatasetRoute
  "/_dashboard/$datasetSlug/settings": typeof DashboardDatasetSlugSettingsRouteRouteWithChildren
  "/_dashboard/$datasetSlug/apps": typeof DashboardDatasetSlugAppsRouteWithChildren
  "/_dashboard/$datasetSlug/compliance": typeof DashboardDatasetSlugComplianceRoute
  "/_dashboard/$datasetSlug/dashboard": typeof DashboardDatasetSlugDashboardRoute
  "/_dashboard/$datasetSlug/profile": typeof DashboardDatasetSlugProfileRoute
  "/_dashboard/$datasetSlug/search": typeof DashboardDatasetSlugSearchRouteWithChildren
  "/_oauth/oauth/response": typeof OauthOauthResponseRoute
  "/_oauth/oauth/verify-link-account-request": typeof OauthOauthVerifyLinkAccountRequestRoute
  "/_oauth/oauth/verify-new-account-request": typeof OauthOauthVerifyNewAccountRequestRoute
  "/_oauth/oauth/verify-new-user-signup": typeof OauthOauthVerifyNewUserSignupRoute
  "/_dashboard/$datasetSlug/data/applications": typeof DashboardDatasetSlugDataApplicationsRouteRouteWithChildren
  "/_dashboard/$datasetSlug/(chats)/chats": typeof DashboardDatasetSlugchatsChatsRouteWithChildren
  "/_dashboard/$datasetSlug/apps/$slug": typeof DashboardDatasetSlugAppsSlugRoute
  "/_dashboard/$datasetSlug/automations/new_automation": typeof DashboardDatasetSlugAutomationsNew_automationRoute
  "/_dashboard/$datasetSlug/custom-ui/$id": typeof DashboardDatasetSlugCustomUiIdRoute
  "/_dashboard/$datasetSlug/docs/$": typeof DashboardDatasetSlugDocsSplatRoute
  "/_dashboard/$datasetSlug/notes/create": typeof DashboardDatasetSlugNotesCreateRoute
  "/_dashboard/$datasetSlug/plugins/$id": typeof DashboardDatasetSlugPluginsIdRoute
  "/_dashboard/$datasetSlug/search/$entityType": typeof DashboardDatasetSlugSearchEntityTypeRoute
  "/_dashboard/$datasetSlug/settings/ai-agents": typeof DashboardDatasetSlugSettingsAiAgentsRoute
  "/_dashboard/$datasetSlug/settings/ai-skills": typeof DashboardDatasetSlugSettingsAiSkillsRoute
  "/_dashboard/$datasetSlug/settings/api": typeof DashboardDatasetSlugSettingsApiRoute
  "/_dashboard/$datasetSlug/settings/applications": typeof DashboardDatasetSlugSettingsApplicationsRoute
  "/_dashboard/$datasetSlug/settings/custom-ui": typeof DashboardDatasetSlugSettingsCustomUiRoute
  "/_dashboard/$datasetSlug/settings/files": typeof DashboardDatasetSlugSettingsFilesRoute
  "/_dashboard/$datasetSlug/settings/global-ai-settings": typeof DashboardDatasetSlugSettingsGlobalAiSettingsRoute
  "/_dashboard/$datasetSlug/settings/interviews": typeof DashboardDatasetSlugSettingsInterviewsRoute
  "/_dashboard/$datasetSlug/settings/live-agents": typeof DashboardDatasetSlugSettingsLiveAgentsRoute
  "/_dashboard/$datasetSlug/settings/plugins": typeof DashboardDatasetSlugSettingsPluginsRoute
  "/_dashboard/$datasetSlug/settings/security": typeof DashboardDatasetSlugSettingsSecurityRoute
  "/_dashboard/$datasetSlug/settings/submissions": typeof DashboardDatasetSlugSettingsSubmissionsRoute
  "/_dashboard/$datasetSlug/settings/tags": typeof DashboardDatasetSlugSettingsTagsRoute
  "/_dashboard/$datasetSlug/settings/users": typeof DashboardDatasetSlugSettingsUsersRouteWithChildren
  "/_dashboard/$datasetSlug/support/$ticketId": typeof DashboardDatasetSlugSupportTicketIdRoute
  "/_dashboard/$datasetSlug/support/new": typeof DashboardDatasetSlugSupportNewRoute
  "/_dashboard/$datasetSlug/tasks/$taskId": typeof DashboardDatasetSlugTasksTaskIdRoute
  "/_dashboard/$datasetSlug/tasks/statistics": typeof DashboardDatasetSlugTasksStatisticsRoute
  "/_dashboard/$datasetSlug/apps/": typeof DashboardDatasetSlugAppsIndexRoute
  "/_dashboard/$datasetSlug/automations/": typeof DashboardDatasetSlugAutomationsIndexRoute
  "/_dashboard/$datasetSlug/docs/": typeof DashboardDatasetSlugDocsIndexRoute
  "/_dashboard/$datasetSlug/library/": typeof DashboardDatasetSlugLibraryIndexRoute
  "/_dashboard/$datasetSlug/notes/": typeof DashboardDatasetSlugNotesIndexRoute
  "/_dashboard/$datasetSlug/support/": typeof DashboardDatasetSlugSupportIndexRoute
  "/_dashboard/$datasetSlug/tasks/": typeof DashboardDatasetSlugTasksIndexRoute
  "/_dashboard/$datasetSlug/(chats)/chats/$conversationId": typeof DashboardDatasetSlugchatsChatsConversationIdRoute
  "/_dashboard/$datasetSlug/apps/syncs/$sourceId": typeof DashboardDatasetSlugAppsSyncsSourceIdRouteWithChildren
  "/_dashboard/$datasetSlug/apps/syncs/writebacks": typeof DashboardDatasetSlugAppsSyncsWritebacksRoute
  "/_dashboard/$datasetSlug/apps_/installed/$appId": typeof DashboardDatasetSlugAppsInstalledAppIdRoute
  "/_dashboard/$datasetSlug/automations/$automationId/builder": typeof DashboardDatasetSlugAutomationsAutomationIdBuilderRoute
  "/_dashboard/$datasetSlug/automations/$automationId/logs": typeof DashboardDatasetSlugAutomationsAutomationIdLogsRouteWithChildren
  "/_dashboard/$datasetSlug/data/applications/activities": typeof DashboardDatasetSlugDataApplicationsActivitiesRoute
  "/_dashboard/$datasetSlug/data/applications/list": typeof DashboardDatasetSlugDataApplicationsListRouteWithChildren
  "/_dashboard/$datasetSlug/data/candidates/$candidateId": typeof DashboardDatasetSlugDataCandidatesCandidateIdRoute
  "/_dashboard/$datasetSlug/data/candidates/create": typeof DashboardDatasetSlugDataCandidatesCreateRoute
  "/_dashboard/$datasetSlug/data/candidates/settings": typeof DashboardDatasetSlugDataCandidatesSettingsRoute
  "/_dashboard/$datasetSlug/data/clients/$clientId": typeof DashboardDatasetSlugDataClientsClientIdRoute
  "/_dashboard/$datasetSlug/data/clients/create": typeof DashboardDatasetSlugDataClientsCreateRoute
  "/_dashboard/$datasetSlug/data/clients/settings": typeof DashboardDatasetSlugDataClientsSettingsRoute
  "/_dashboard/$datasetSlug/data/contacts/$contactId": typeof DashboardDatasetSlugDataContactsContactIdRoute
  "/_dashboard/$datasetSlug/data/contacts/create": typeof DashboardDatasetSlugDataContactsCreateRoute
  "/_dashboard/$datasetSlug/data/contacts/settings": typeof DashboardDatasetSlugDataContactsSettingsRoute
  "/_dashboard/$datasetSlug/data/custom/create": typeof DashboardDatasetSlugDataCustomCreateRoute
  "/_dashboard/$datasetSlug/data/jobs/$jobId": typeof DashboardDatasetSlugDataJobsJobIdRoute
  "/_dashboard/$datasetSlug/data/jobs/create": typeof DashboardDatasetSlugDataJobsCreateRoute
  "/_dashboard/$datasetSlug/data/jobs/settings": typeof DashboardDatasetSlugDataJobsSettingsRoute
  "/_dashboard/$datasetSlug/data/lists/$listId": typeof DashboardDatasetSlugDataListsListIdRoute
  "/_dashboard/$datasetSlug/data/placements/settings": typeof DashboardDatasetSlugDataPlacementsSettingsRoute
  "/_dashboard/$datasetSlug/data/skills/$skillId": typeof DashboardDatasetSlugDataSkillsSkillIdRoute
  "/_dashboard/$datasetSlug/data/skills/review": typeof DashboardDatasetSlugDataSkillsReviewRoute
  "/_dashboard/$datasetSlug/data/skills/settings": typeof DashboardDatasetSlugDataSkillsSettingsRoute
  "/_dashboard/$datasetSlug/notes/$id/edit": typeof DashboardDatasetSlugNotesIdEditRoute
  "/_dashboard/$datasetSlug/settings/ai-agents_/$id": typeof DashboardDatasetSlugSettingsAiAgentsIdRoute
  "/_dashboard/$datasetSlug/settings/ai-agents_/create": typeof DashboardDatasetSlugSettingsAiAgentsCreateRoute
  "/_dashboard/$datasetSlug/settings/live-agents_/$id": typeof DashboardDatasetSlugSettingsLiveAgentsIdRouteWithChildren
  "/_dashboard/$datasetSlug/settings/live-agents_/create": typeof DashboardDatasetSlugSettingsLiveAgentsCreateRoute
  "/_dashboard/$datasetSlug/settings/permissions/create": typeof DashboardDatasetSlugSettingsPermissionsCreateRoute
  "/_dashboard/$datasetSlug/settings/tags_/$id": typeof DashboardDatasetSlugSettingsTagsIdRoute
  "/_dashboard/$datasetSlug/apps/installed/": typeof DashboardDatasetSlugAppsInstalledIndexRoute
  "/_dashboard/$datasetSlug/apps/syncs/": typeof DashboardDatasetSlugAppsSyncsIndexRoute
  "/_dashboard/$datasetSlug/automations/$automationId/": typeof DashboardDatasetSlugAutomationsAutomationIdIndexRoute
  "/_dashboard/$datasetSlug/data/candidates/": typeof DashboardDatasetSlugDataCandidatesIndexRoute
  "/_dashboard/$datasetSlug/data/clients/": typeof DashboardDatasetSlugDataClientsIndexRoute
  "/_dashboard/$datasetSlug/data/contacts/": typeof DashboardDatasetSlugDataContactsIndexRoute
  "/_dashboard/$datasetSlug/data/cv-sends/": typeof DashboardDatasetSlugDataCvSendsIndexRoute
  "/_dashboard/$datasetSlug/data/job-submissions/": typeof DashboardDatasetSlugDataJobSubmissionsIndexRoute
  "/_dashboard/$datasetSlug/data/jobs/": typeof DashboardDatasetSlugDataJobsIndexRoute
  "/_dashboard/$datasetSlug/data/lists/": typeof DashboardDatasetSlugDataListsIndexRoute
  "/_dashboard/$datasetSlug/data/placements/": typeof DashboardDatasetSlugDataPlacementsIndexRoute
  "/_dashboard/$datasetSlug/data/skills/": typeof DashboardDatasetSlugDataSkillsIndexRoute
  "/_dashboard/$datasetSlug/settings/email-settings/": typeof DashboardDatasetSlugSettingsEmailSettingsIndexRoute
  "/_dashboard/$datasetSlug/settings/linked-accounts/": typeof DashboardDatasetSlugSettingsLinkedAccountsIndexRoute
  "/_dashboard/$datasetSlug/settings/permissions/": typeof DashboardDatasetSlugSettingsPermissionsIndexRoute
  "/_dashboard/$datasetSlug/apps/syncs/$sourceId/$sourceObjectId": typeof DashboardDatasetSlugAppsSyncsSourceIdSourceObjectIdRoute
  "/_dashboard/$datasetSlug/automations/$automationId/logs/$journeyId": typeof DashboardDatasetSlugAutomationsAutomationIdLogsJourneyIdRoute
  "/_dashboard/$datasetSlug/data/applications/list/$applicationId": typeof DashboardDatasetSlugDataApplicationsListApplicationIdRoute
  "/_dashboard/$datasetSlug/data/applications/table/$applicationId": typeof DashboardDatasetSlugDataApplicationsTableApplicationIdRoute
  "/_dashboard/$datasetSlug/data/candidates/edit/$id": typeof DashboardDatasetSlugDataCandidatesEditIdRoute
  "/_dashboard/$datasetSlug/data/candidates/view/$viewName": typeof DashboardDatasetSlugDataCandidatesViewViewNameRoute
  "/_dashboard/$datasetSlug/data/clients/edit/$id": typeof DashboardDatasetSlugDataClientsEditIdRoute
  "/_dashboard/$datasetSlug/data/clients/view/$viewName": typeof DashboardDatasetSlugDataClientsViewViewNameRoute
  "/_dashboard/$datasetSlug/data/contacts/edit/$id": typeof DashboardDatasetSlugDataContactsEditIdRoute
  "/_dashboard/$datasetSlug/data/contacts/view/$viewName": typeof DashboardDatasetSlugDataContactsViewViewNameRoute
  "/_dashboard/$datasetSlug/data/jobs/edit/$id": typeof DashboardDatasetSlugDataJobsEditIdRoute
  "/_dashboard/$datasetSlug/data/jobs/view/$viewName": typeof DashboardDatasetSlugDataJobsViewViewNameRoute
  "/_dashboard/$datasetSlug/data/skills/sets/$set_id": typeof DashboardDatasetSlugDataSkillsSetsSet_idRoute
  "/_dashboard/$datasetSlug/settings/email-settings/templates/create": typeof DashboardDatasetSlugSettingsEmailSettingsTemplatesCreateRoute
  "/_dashboard/$datasetSlug/settings/live-agents_/$id/edit": typeof DashboardDatasetSlugSettingsLiveAgentsIdEditRoute
  "/_dashboard/$datasetSlug/settings/live-agents_/$id/runs": typeof DashboardDatasetSlugSettingsLiveAgentsIdRunsRouteWithChildren
  "/_dashboard/$datasetSlug/settings/permissions/edit/$id": typeof DashboardDatasetSlugSettingsPermissionsEditIdRoute
  "/_dashboard/$datasetSlug/settings/users/$id/edit": typeof DashboardDatasetSlugSettingsUsersIdEditRoute
  "/_dashboard/$datasetSlug/data/applications/table/": typeof DashboardDatasetSlugDataApplicationsTableIndexRoute
  "/_dashboard/$datasetSlug/data/skills/sets/": typeof DashboardDatasetSlugDataSkillsSetsIndexRoute
  "/_dashboard/$datasetSlug/settings/email-settings/sync-settings/": typeof DashboardDatasetSlugSettingsEmailSettingsSyncSettingsIndexRoute
  "/_dashboard/$datasetSlug/settings/email-settings/templates/": typeof DashboardDatasetSlugSettingsEmailSettingsTemplatesIndexRoute
  "/_dashboard/$datasetSlug/settings/live-agents_/$id/": typeof DashboardDatasetSlugSettingsLiveAgentsIdIndexRoute
  "/_dashboard/$datasetSlug/(chats)/chats_/$conversationId/searches/$searchId": typeof DashboardDatasetSlugchatsChatsConversationIdSearchesSearchIdRoute
  "/_dashboard/$datasetSlug/data/custom/details/$id/create": typeof DashboardDatasetSlugDataCustomDetailsIdCreateRoute
  "/_dashboard/$datasetSlug/data/custom/details/$id/kanban": typeof DashboardDatasetSlugDataCustomDetailsIdKanbanRoute
  "/_dashboard/$datasetSlug/data/custom/details/$id/settings": typeof DashboardDatasetSlugDataCustomDetailsIdSettingsRoute
  "/_dashboard/$datasetSlug/settings/email-settings/templates/edit/$id": typeof DashboardDatasetSlugSettingsEmailSettingsTemplatesEditIdRoute
  "/_dashboard/$datasetSlug/settings/live-agents_/$id/runs/$runId": typeof DashboardDatasetSlugSettingsLiveAgentsIdRunsRunIdRoute
  "/_dashboard/$datasetSlug/settings/live-agents_/$id/runs/": typeof DashboardDatasetSlugSettingsLiveAgentsIdRunsIndexRoute
  "/_dashboard/$datasetSlug/data/custom/details/$id/edit/$rowId": typeof DashboardDatasetSlugDataCustomDetailsIdEditRowIdRoute
  "/_dashboard/$datasetSlug/data/custom/details/$id/table/$customDetailsId": typeof DashboardDatasetSlugDataCustomDetailsIdTableCustomDetailsIdRoute
  "/_dashboard/$datasetSlug/data/custom/details/$id/view/$viewName": typeof DashboardDatasetSlugDataCustomDetailsIdViewViewNameRoute
  "/_dashboard/$datasetSlug/data/custom/details/$id/table/": typeof DashboardDatasetSlugDataCustomDetailsIdTableIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/404"
    | "/$datasetSlug"
    | "/login"
    | "/magic-link-sent"
    | "/mfa"
    | "/openapi-oauth"
    | "/select-dataset"
    | "/verify"
    | "/verify-user-dataset"
    | "/$datasetSlug/settings"
    | "/$datasetSlug/apps"
    | "/$datasetSlug/compliance"
    | "/$datasetSlug/dashboard"
    | "/$datasetSlug/profile"
    | "/$datasetSlug/search"
    | "/oauth/response"
    | "/oauth/verify-link-account-request"
    | "/oauth/verify-new-account-request"
    | "/oauth/verify-new-user-signup"
    | "/$datasetSlug/data/applications"
    | "/$datasetSlug/chats"
    | "/$datasetSlug/apps/$slug"
    | "/$datasetSlug/automations/new_automation"
    | "/$datasetSlug/custom-ui/$id"
    | "/$datasetSlug/docs/$"
    | "/$datasetSlug/notes/create"
    | "/$datasetSlug/plugins/$id"
    | "/$datasetSlug/search/$entityType"
    | "/$datasetSlug/settings/ai-agents"
    | "/$datasetSlug/settings/ai-skills"
    | "/$datasetSlug/settings/api"
    | "/$datasetSlug/settings/applications"
    | "/$datasetSlug/settings/custom-ui"
    | "/$datasetSlug/settings/files"
    | "/$datasetSlug/settings/global-ai-settings"
    | "/$datasetSlug/settings/interviews"
    | "/$datasetSlug/settings/live-agents"
    | "/$datasetSlug/settings/plugins"
    | "/$datasetSlug/settings/security"
    | "/$datasetSlug/settings/submissions"
    | "/$datasetSlug/settings/tags"
    | "/$datasetSlug/settings/users"
    | "/$datasetSlug/support/$ticketId"
    | "/$datasetSlug/support/new"
    | "/$datasetSlug/tasks/$taskId"
    | "/$datasetSlug/tasks/statistics"
    | "/$datasetSlug/apps/"
    | "/$datasetSlug/automations/"
    | "/$datasetSlug/docs/"
    | "/$datasetSlug/library/"
    | "/$datasetSlug/notes/"
    | "/$datasetSlug/support/"
    | "/$datasetSlug/tasks/"
    | "/$datasetSlug/chats/$conversationId"
    | "/$datasetSlug/apps/syncs/$sourceId"
    | "/$datasetSlug/apps/syncs/writebacks"
    | "/$datasetSlug/apps/installed/$appId"
    | "/$datasetSlug/automations/$automationId/builder"
    | "/$datasetSlug/automations/$automationId/logs"
    | "/$datasetSlug/data/applications/activities"
    | "/$datasetSlug/data/applications/list"
    | "/$datasetSlug/data/candidates/$candidateId"
    | "/$datasetSlug/data/candidates/create"
    | "/$datasetSlug/data/candidates/settings"
    | "/$datasetSlug/data/clients/$clientId"
    | "/$datasetSlug/data/clients/create"
    | "/$datasetSlug/data/clients/settings"
    | "/$datasetSlug/data/contacts/$contactId"
    | "/$datasetSlug/data/contacts/create"
    | "/$datasetSlug/data/contacts/settings"
    | "/$datasetSlug/data/custom/create"
    | "/$datasetSlug/data/jobs/$jobId"
    | "/$datasetSlug/data/jobs/create"
    | "/$datasetSlug/data/jobs/settings"
    | "/$datasetSlug/data/lists/$listId"
    | "/$datasetSlug/data/placements/settings"
    | "/$datasetSlug/data/skills/$skillId"
    | "/$datasetSlug/data/skills/review"
    | "/$datasetSlug/data/skills/settings"
    | "/$datasetSlug/notes/$id/edit"
    | "/$datasetSlug/settings/ai-agents/$id"
    | "/$datasetSlug/settings/ai-agents/create"
    | "/$datasetSlug/settings/live-agents/$id"
    | "/$datasetSlug/settings/live-agents/create"
    | "/$datasetSlug/settings/permissions/create"
    | "/$datasetSlug/settings/tags/$id"
    | "/$datasetSlug/apps/installed/"
    | "/$datasetSlug/apps/syncs/"
    | "/$datasetSlug/automations/$automationId/"
    | "/$datasetSlug/data/candidates/"
    | "/$datasetSlug/data/clients/"
    | "/$datasetSlug/data/contacts/"
    | "/$datasetSlug/data/cv-sends/"
    | "/$datasetSlug/data/job-submissions/"
    | "/$datasetSlug/data/jobs/"
    | "/$datasetSlug/data/lists/"
    | "/$datasetSlug/data/placements/"
    | "/$datasetSlug/data/skills/"
    | "/$datasetSlug/settings/email-settings/"
    | "/$datasetSlug/settings/linked-accounts/"
    | "/$datasetSlug/settings/permissions/"
    | "/$datasetSlug/apps/syncs/$sourceId/$sourceObjectId"
    | "/$datasetSlug/automations/$automationId/logs/$journeyId"
    | "/$datasetSlug/data/applications/list/$applicationId"
    | "/$datasetSlug/data/applications/table/$applicationId"
    | "/$datasetSlug/data/candidates/edit/$id"
    | "/$datasetSlug/data/candidates/view/$viewName"
    | "/$datasetSlug/data/clients/edit/$id"
    | "/$datasetSlug/data/clients/view/$viewName"
    | "/$datasetSlug/data/contacts/edit/$id"
    | "/$datasetSlug/data/contacts/view/$viewName"
    | "/$datasetSlug/data/jobs/edit/$id"
    | "/$datasetSlug/data/jobs/view/$viewName"
    | "/$datasetSlug/data/skills/sets/$set_id"
    | "/$datasetSlug/settings/email-settings/templates/create"
    | "/$datasetSlug/settings/live-agents/$id/edit"
    | "/$datasetSlug/settings/live-agents/$id/runs"
    | "/$datasetSlug/settings/permissions/edit/$id"
    | "/$datasetSlug/settings/users/$id/edit"
    | "/$datasetSlug/data/applications/table/"
    | "/$datasetSlug/data/skills/sets/"
    | "/$datasetSlug/settings/email-settings/sync-settings/"
    | "/$datasetSlug/settings/email-settings/templates/"
    | "/$datasetSlug/settings/live-agents/$id/"
    | "/$datasetSlug/chats/$conversationId/searches/$searchId"
    | "/$datasetSlug/data/custom/details/$id/create"
    | "/$datasetSlug/data/custom/details/$id/kanban"
    | "/$datasetSlug/data/custom/details/$id/settings"
    | "/$datasetSlug/settings/email-settings/templates/edit/$id"
    | "/$datasetSlug/settings/live-agents/$id/runs/$runId"
    | "/$datasetSlug/settings/live-agents/$id/runs/"
    | "/$datasetSlug/data/custom/details/$id/edit/$rowId"
    | "/$datasetSlug/data/custom/details/$id/table/$customDetailsId"
    | "/$datasetSlug/data/custom/details/$id/view/$viewName"
    | "/$datasetSlug/data/custom/details/$id/table/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/404"
    | "/$datasetSlug"
    | "/login"
    | "/magic-link-sent"
    | "/mfa"
    | "/openapi-oauth"
    | "/select-dataset"
    | "/verify"
    | "/verify-user-dataset"
    | "/$datasetSlug/settings"
    | "/$datasetSlug/compliance"
    | "/$datasetSlug/dashboard"
    | "/$datasetSlug/profile"
    | "/$datasetSlug/search"
    | "/oauth/response"
    | "/oauth/verify-link-account-request"
    | "/oauth/verify-new-account-request"
    | "/oauth/verify-new-user-signup"
    | "/$datasetSlug/data/applications"
    | "/$datasetSlug/chats"
    | "/$datasetSlug/apps/$slug"
    | "/$datasetSlug/automations/new_automation"
    | "/$datasetSlug/custom-ui/$id"
    | "/$datasetSlug/docs/$"
    | "/$datasetSlug/notes/create"
    | "/$datasetSlug/plugins/$id"
    | "/$datasetSlug/search/$entityType"
    | "/$datasetSlug/settings/ai-agents"
    | "/$datasetSlug/settings/ai-skills"
    | "/$datasetSlug/settings/api"
    | "/$datasetSlug/settings/applications"
    | "/$datasetSlug/settings/custom-ui"
    | "/$datasetSlug/settings/files"
    | "/$datasetSlug/settings/global-ai-settings"
    | "/$datasetSlug/settings/interviews"
    | "/$datasetSlug/settings/live-agents"
    | "/$datasetSlug/settings/plugins"
    | "/$datasetSlug/settings/security"
    | "/$datasetSlug/settings/submissions"
    | "/$datasetSlug/settings/tags"
    | "/$datasetSlug/settings/users"
    | "/$datasetSlug/support/$ticketId"
    | "/$datasetSlug/support/new"
    | "/$datasetSlug/tasks/$taskId"
    | "/$datasetSlug/tasks/statistics"
    | "/$datasetSlug/apps"
    | "/$datasetSlug/automations"
    | "/$datasetSlug/docs"
    | "/$datasetSlug/library"
    | "/$datasetSlug/notes"
    | "/$datasetSlug/support"
    | "/$datasetSlug/tasks"
    | "/$datasetSlug/chats/$conversationId"
    | "/$datasetSlug/apps/syncs/$sourceId"
    | "/$datasetSlug/apps/syncs/writebacks"
    | "/$datasetSlug/apps/installed/$appId"
    | "/$datasetSlug/automations/$automationId/builder"
    | "/$datasetSlug/automations/$automationId/logs"
    | "/$datasetSlug/data/applications/activities"
    | "/$datasetSlug/data/applications/list"
    | "/$datasetSlug/data/candidates/$candidateId"
    | "/$datasetSlug/data/candidates/create"
    | "/$datasetSlug/data/candidates/settings"
    | "/$datasetSlug/data/clients/$clientId"
    | "/$datasetSlug/data/clients/create"
    | "/$datasetSlug/data/clients/settings"
    | "/$datasetSlug/data/contacts/$contactId"
    | "/$datasetSlug/data/contacts/create"
    | "/$datasetSlug/data/contacts/settings"
    | "/$datasetSlug/data/custom/create"
    | "/$datasetSlug/data/jobs/$jobId"
    | "/$datasetSlug/data/jobs/create"
    | "/$datasetSlug/data/jobs/settings"
    | "/$datasetSlug/data/lists/$listId"
    | "/$datasetSlug/data/placements/settings"
    | "/$datasetSlug/data/skills/$skillId"
    | "/$datasetSlug/data/skills/review"
    | "/$datasetSlug/data/skills/settings"
    | "/$datasetSlug/notes/$id/edit"
    | "/$datasetSlug/settings/ai-agents/$id"
    | "/$datasetSlug/settings/ai-agents/create"
    | "/$datasetSlug/settings/live-agents/create"
    | "/$datasetSlug/settings/permissions/create"
    | "/$datasetSlug/settings/tags/$id"
    | "/$datasetSlug/apps/installed"
    | "/$datasetSlug/apps/syncs"
    | "/$datasetSlug/automations/$automationId"
    | "/$datasetSlug/data/candidates"
    | "/$datasetSlug/data/clients"
    | "/$datasetSlug/data/contacts"
    | "/$datasetSlug/data/cv-sends"
    | "/$datasetSlug/data/job-submissions"
    | "/$datasetSlug/data/jobs"
    | "/$datasetSlug/data/lists"
    | "/$datasetSlug/data/placements"
    | "/$datasetSlug/data/skills"
    | "/$datasetSlug/settings/email-settings"
    | "/$datasetSlug/settings/linked-accounts"
    | "/$datasetSlug/settings/permissions"
    | "/$datasetSlug/apps/syncs/$sourceId/$sourceObjectId"
    | "/$datasetSlug/automations/$automationId/logs/$journeyId"
    | "/$datasetSlug/data/applications/list/$applicationId"
    | "/$datasetSlug/data/applications/table/$applicationId"
    | "/$datasetSlug/data/candidates/edit/$id"
    | "/$datasetSlug/data/candidates/view/$viewName"
    | "/$datasetSlug/data/clients/edit/$id"
    | "/$datasetSlug/data/clients/view/$viewName"
    | "/$datasetSlug/data/contacts/edit/$id"
    | "/$datasetSlug/data/contacts/view/$viewName"
    | "/$datasetSlug/data/jobs/edit/$id"
    | "/$datasetSlug/data/jobs/view/$viewName"
    | "/$datasetSlug/data/skills/sets/$set_id"
    | "/$datasetSlug/settings/email-settings/templates/create"
    | "/$datasetSlug/settings/live-agents/$id/edit"
    | "/$datasetSlug/settings/permissions/edit/$id"
    | "/$datasetSlug/settings/users/$id/edit"
    | "/$datasetSlug/data/applications/table"
    | "/$datasetSlug/data/skills/sets"
    | "/$datasetSlug/settings/email-settings/sync-settings"
    | "/$datasetSlug/settings/email-settings/templates"
    | "/$datasetSlug/settings/live-agents/$id"
    | "/$datasetSlug/chats/$conversationId/searches/$searchId"
    | "/$datasetSlug/data/custom/details/$id/create"
    | "/$datasetSlug/data/custom/details/$id/kanban"
    | "/$datasetSlug/data/custom/details/$id/settings"
    | "/$datasetSlug/settings/email-settings/templates/edit/$id"
    | "/$datasetSlug/settings/live-agents/$id/runs/$runId"
    | "/$datasetSlug/settings/live-agents/$id/runs"
    | "/$datasetSlug/data/custom/details/$id/edit/$rowId"
    | "/$datasetSlug/data/custom/details/$id/table/$customDetailsId"
    | "/$datasetSlug/data/custom/details/$id/view/$viewName"
    | "/$datasetSlug/data/custom/details/$id/table"
  id:
    | "__root__"
    | "/"
    | "/404"
    | "/_dashboard"
    | "/_oauth"
    | "/_public"
    | "/_dashboard/$datasetSlug"
    | "/_public/login"
    | "/_public/magic-link-sent"
    | "/_public/mfa"
    | "/_public/openapi-oauth"
    | "/_public/select-dataset"
    | "/_public/verify"
    | "/_public/verify-user-dataset"
    | "/_dashboard/$datasetSlug/settings"
    | "/_dashboard/$datasetSlug/apps"
    | "/_dashboard/$datasetSlug/compliance"
    | "/_dashboard/$datasetSlug/dashboard"
    | "/_dashboard/$datasetSlug/profile"
    | "/_dashboard/$datasetSlug/search"
    | "/_oauth/oauth/response"
    | "/_oauth/oauth/verify-link-account-request"
    | "/_oauth/oauth/verify-new-account-request"
    | "/_oauth/oauth/verify-new-user-signup"
    | "/_dashboard/$datasetSlug/data/applications"
    | "/_dashboard/$datasetSlug/(chats)/chats"
    | "/_dashboard/$datasetSlug/apps/$slug"
    | "/_dashboard/$datasetSlug/automations/new_automation"
    | "/_dashboard/$datasetSlug/custom-ui/$id"
    | "/_dashboard/$datasetSlug/docs/$"
    | "/_dashboard/$datasetSlug/notes/create"
    | "/_dashboard/$datasetSlug/plugins/$id"
    | "/_dashboard/$datasetSlug/search/$entityType"
    | "/_dashboard/$datasetSlug/settings/ai-agents"
    | "/_dashboard/$datasetSlug/settings/ai-skills"
    | "/_dashboard/$datasetSlug/settings/api"
    | "/_dashboard/$datasetSlug/settings/applications"
    | "/_dashboard/$datasetSlug/settings/custom-ui"
    | "/_dashboard/$datasetSlug/settings/files"
    | "/_dashboard/$datasetSlug/settings/global-ai-settings"
    | "/_dashboard/$datasetSlug/settings/interviews"
    | "/_dashboard/$datasetSlug/settings/live-agents"
    | "/_dashboard/$datasetSlug/settings/plugins"
    | "/_dashboard/$datasetSlug/settings/security"
    | "/_dashboard/$datasetSlug/settings/submissions"
    | "/_dashboard/$datasetSlug/settings/tags"
    | "/_dashboard/$datasetSlug/settings/users"
    | "/_dashboard/$datasetSlug/support/$ticketId"
    | "/_dashboard/$datasetSlug/support/new"
    | "/_dashboard/$datasetSlug/tasks/$taskId"
    | "/_dashboard/$datasetSlug/tasks/statistics"
    | "/_dashboard/$datasetSlug/apps/"
    | "/_dashboard/$datasetSlug/automations/"
    | "/_dashboard/$datasetSlug/docs/"
    | "/_dashboard/$datasetSlug/library/"
    | "/_dashboard/$datasetSlug/notes/"
    | "/_dashboard/$datasetSlug/support/"
    | "/_dashboard/$datasetSlug/tasks/"
    | "/_dashboard/$datasetSlug/(chats)/chats/$conversationId"
    | "/_dashboard/$datasetSlug/apps/syncs/$sourceId"
    | "/_dashboard/$datasetSlug/apps/syncs/writebacks"
    | "/_dashboard/$datasetSlug/apps_/installed/$appId"
    | "/_dashboard/$datasetSlug/automations/$automationId/builder"
    | "/_dashboard/$datasetSlug/automations/$automationId/logs"
    | "/_dashboard/$datasetSlug/data/applications/activities"
    | "/_dashboard/$datasetSlug/data/applications/list"
    | "/_dashboard/$datasetSlug/data/candidates/$candidateId"
    | "/_dashboard/$datasetSlug/data/candidates/create"
    | "/_dashboard/$datasetSlug/data/candidates/settings"
    | "/_dashboard/$datasetSlug/data/clients/$clientId"
    | "/_dashboard/$datasetSlug/data/clients/create"
    | "/_dashboard/$datasetSlug/data/clients/settings"
    | "/_dashboard/$datasetSlug/data/contacts/$contactId"
    | "/_dashboard/$datasetSlug/data/contacts/create"
    | "/_dashboard/$datasetSlug/data/contacts/settings"
    | "/_dashboard/$datasetSlug/data/custom/create"
    | "/_dashboard/$datasetSlug/data/jobs/$jobId"
    | "/_dashboard/$datasetSlug/data/jobs/create"
    | "/_dashboard/$datasetSlug/data/jobs/settings"
    | "/_dashboard/$datasetSlug/data/lists/$listId"
    | "/_dashboard/$datasetSlug/data/placements/settings"
    | "/_dashboard/$datasetSlug/data/skills/$skillId"
    | "/_dashboard/$datasetSlug/data/skills/review"
    | "/_dashboard/$datasetSlug/data/skills/settings"
    | "/_dashboard/$datasetSlug/notes/$id/edit"
    | "/_dashboard/$datasetSlug/settings/ai-agents_/$id"
    | "/_dashboard/$datasetSlug/settings/ai-agents_/create"
    | "/_dashboard/$datasetSlug/settings/live-agents_/$id"
    | "/_dashboard/$datasetSlug/settings/live-agents_/create"
    | "/_dashboard/$datasetSlug/settings/permissions/create"
    | "/_dashboard/$datasetSlug/settings/tags_/$id"
    | "/_dashboard/$datasetSlug/apps/installed/"
    | "/_dashboard/$datasetSlug/apps/syncs/"
    | "/_dashboard/$datasetSlug/automations/$automationId/"
    | "/_dashboard/$datasetSlug/data/candidates/"
    | "/_dashboard/$datasetSlug/data/clients/"
    | "/_dashboard/$datasetSlug/data/contacts/"
    | "/_dashboard/$datasetSlug/data/cv-sends/"
    | "/_dashboard/$datasetSlug/data/job-submissions/"
    | "/_dashboard/$datasetSlug/data/jobs/"
    | "/_dashboard/$datasetSlug/data/lists/"
    | "/_dashboard/$datasetSlug/data/placements/"
    | "/_dashboard/$datasetSlug/data/skills/"
    | "/_dashboard/$datasetSlug/settings/email-settings/"
    | "/_dashboard/$datasetSlug/settings/linked-accounts/"
    | "/_dashboard/$datasetSlug/settings/permissions/"
    | "/_dashboard/$datasetSlug/apps/syncs/$sourceId/$sourceObjectId"
    | "/_dashboard/$datasetSlug/automations/$automationId/logs/$journeyId"
    | "/_dashboard/$datasetSlug/data/applications/list/$applicationId"
    | "/_dashboard/$datasetSlug/data/applications/table/$applicationId"
    | "/_dashboard/$datasetSlug/data/candidates/edit/$id"
    | "/_dashboard/$datasetSlug/data/candidates/view/$viewName"
    | "/_dashboard/$datasetSlug/data/clients/edit/$id"
    | "/_dashboard/$datasetSlug/data/clients/view/$viewName"
    | "/_dashboard/$datasetSlug/data/contacts/edit/$id"
    | "/_dashboard/$datasetSlug/data/contacts/view/$viewName"
    | "/_dashboard/$datasetSlug/data/jobs/edit/$id"
    | "/_dashboard/$datasetSlug/data/jobs/view/$viewName"
    | "/_dashboard/$datasetSlug/data/skills/sets/$set_id"
    | "/_dashboard/$datasetSlug/settings/email-settings/templates/create"
    | "/_dashboard/$datasetSlug/settings/live-agents_/$id/edit"
    | "/_dashboard/$datasetSlug/settings/live-agents_/$id/runs"
    | "/_dashboard/$datasetSlug/settings/permissions/edit/$id"
    | "/_dashboard/$datasetSlug/settings/users/$id/edit"
    | "/_dashboard/$datasetSlug/data/applications/table/"
    | "/_dashboard/$datasetSlug/data/skills/sets/"
    | "/_dashboard/$datasetSlug/settings/email-settings/sync-settings/"
    | "/_dashboard/$datasetSlug/settings/email-settings/templates/"
    | "/_dashboard/$datasetSlug/settings/live-agents_/$id/"
    | "/_dashboard/$datasetSlug/(chats)/chats_/$conversationId/searches/$searchId"
    | "/_dashboard/$datasetSlug/data/custom/details/$id/create"
    | "/_dashboard/$datasetSlug/data/custom/details/$id/kanban"
    | "/_dashboard/$datasetSlug/data/custom/details/$id/settings"
    | "/_dashboard/$datasetSlug/settings/email-settings/templates/edit/$id"
    | "/_dashboard/$datasetSlug/settings/live-agents_/$id/runs/$runId"
    | "/_dashboard/$datasetSlug/settings/live-agents_/$id/runs/"
    | "/_dashboard/$datasetSlug/data/custom/details/$id/edit/$rowId"
    | "/_dashboard/$datasetSlug/data/custom/details/$id/table/$customDetailsId"
    | "/_dashboard/$datasetSlug/data/custom/details/$id/view/$viewName"
    | "/_dashboard/$datasetSlug/data/custom/details/$id/table/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  R404Route: typeof R404Route
  DashboardRoute: typeof DashboardRouteWithChildren
  OauthRoute: typeof OauthRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/404": {
      id: "/404"
      path: "/404"
      fullPath: "/404"
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_dashboard": {
      id: "/_dashboard"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_oauth": {
      id: "/_oauth"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof OauthRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_public": {
      id: "/_public"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_dashboard/$datasetSlug": {
      id: "/_dashboard/$datasetSlug"
      path: "/$datasetSlug"
      fullPath: "/$datasetSlug"
      preLoaderRoute: typeof DashboardDatasetSlugRouteImport
      parentRoute: typeof DashboardRoute
    }
    "/_public/login": {
      id: "/_public/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    "/_public/magic-link-sent": {
      id: "/_public/magic-link-sent"
      path: "/magic-link-sent"
      fullPath: "/magic-link-sent"
      preLoaderRoute: typeof PublicMagicLinkSentRouteImport
      parentRoute: typeof PublicRoute
    }
    "/_public/mfa": {
      id: "/_public/mfa"
      path: "/mfa"
      fullPath: "/mfa"
      preLoaderRoute: typeof PublicMfaRouteImport
      parentRoute: typeof PublicRoute
    }
    "/_public/openapi-oauth": {
      id: "/_public/openapi-oauth"
      path: "/openapi-oauth"
      fullPath: "/openapi-oauth"
      preLoaderRoute: typeof PublicOpenapiOauthRouteImport
      parentRoute: typeof PublicRoute
    }
    "/_public/select-dataset": {
      id: "/_public/select-dataset"
      path: "/select-dataset"
      fullPath: "/select-dataset"
      preLoaderRoute: typeof PublicSelectDatasetRouteImport
      parentRoute: typeof PublicRoute
    }
    "/_public/verify": {
      id: "/_public/verify"
      path: "/verify"
      fullPath: "/verify"
      preLoaderRoute: typeof PublicVerifyRouteImport
      parentRoute: typeof PublicRoute
    }
    "/_public/verify-user-dataset": {
      id: "/_public/verify-user-dataset"
      path: "/verify-user-dataset"
      fullPath: "/verify-user-dataset"
      preLoaderRoute: typeof PublicVerifyUserDatasetRouteImport
      parentRoute: typeof PublicRoute
    }
    "/_dashboard/$datasetSlug/apps": {
      id: "/_dashboard/$datasetSlug/apps"
      path: "/apps"
      fullPath: "/$datasetSlug/apps"
      preLoaderRoute: typeof DashboardDatasetSlugAppsRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/compliance": {
      id: "/_dashboard/$datasetSlug/compliance"
      path: "/compliance"
      fullPath: "/$datasetSlug/compliance"
      preLoaderRoute: typeof DashboardDatasetSlugComplianceRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/dashboard": {
      id: "/_dashboard/$datasetSlug/dashboard"
      path: "/dashboard"
      fullPath: "/$datasetSlug/dashboard"
      preLoaderRoute: typeof DashboardDatasetSlugDashboardRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/profile": {
      id: "/_dashboard/$datasetSlug/profile"
      path: "/profile"
      fullPath: "/$datasetSlug/profile"
      preLoaderRoute: typeof DashboardDatasetSlugProfileRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/search": {
      id: "/_dashboard/$datasetSlug/search"
      path: "/search"
      fullPath: "/$datasetSlug/search"
      preLoaderRoute: typeof DashboardDatasetSlugSearchRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/settings": {
      id: "/_dashboard/$datasetSlug/settings"
      path: "/settings"
      fullPath: "/$datasetSlug/settings"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsRouteRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_oauth/oauth/response": {
      id: "/_oauth/oauth/response"
      path: "/oauth/response"
      fullPath: "/oauth/response"
      preLoaderRoute: typeof OauthOauthResponseRouteImport
      parentRoute: typeof OauthRoute
    }
    "/_oauth/oauth/verify-link-account-request": {
      id: "/_oauth/oauth/verify-link-account-request"
      path: "/oauth/verify-link-account-request"
      fullPath: "/oauth/verify-link-account-request"
      preLoaderRoute: typeof OauthOauthVerifyLinkAccountRequestRouteImport
      parentRoute: typeof OauthRoute
    }
    "/_oauth/oauth/verify-new-account-request": {
      id: "/_oauth/oauth/verify-new-account-request"
      path: "/oauth/verify-new-account-request"
      fullPath: "/oauth/verify-new-account-request"
      preLoaderRoute: typeof OauthOauthVerifyNewAccountRequestRouteImport
      parentRoute: typeof OauthRoute
    }
    "/_oauth/oauth/verify-new-user-signup": {
      id: "/_oauth/oauth/verify-new-user-signup"
      path: "/oauth/verify-new-user-signup"
      fullPath: "/oauth/verify-new-user-signup"
      preLoaderRoute: typeof OauthOauthVerifyNewUserSignupRouteImport
      parentRoute: typeof OauthRoute
    }
    "/_dashboard/$datasetSlug/(chats)/chats": {
      id: "/_dashboard/$datasetSlug/(chats)/chats"
      path: "/chats"
      fullPath: "/$datasetSlug/chats"
      preLoaderRoute: typeof DashboardDatasetSlugchatsChatsRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/apps/": {
      id: "/_dashboard/$datasetSlug/apps/"
      path: "/"
      fullPath: "/$datasetSlug/apps/"
      preLoaderRoute: typeof DashboardDatasetSlugAppsIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugAppsRoute
    }
    "/_dashboard/$datasetSlug/apps/$slug": {
      id: "/_dashboard/$datasetSlug/apps/$slug"
      path: "/$slug"
      fullPath: "/$datasetSlug/apps/$slug"
      preLoaderRoute: typeof DashboardDatasetSlugAppsSlugRouteImport
      parentRoute: typeof DashboardDatasetSlugAppsRoute
    }
    "/_dashboard/$datasetSlug/automations/": {
      id: "/_dashboard/$datasetSlug/automations/"
      path: "/automations"
      fullPath: "/$datasetSlug/automations/"
      preLoaderRoute: typeof DashboardDatasetSlugAutomationsIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/automations/new_automation": {
      id: "/_dashboard/$datasetSlug/automations/new_automation"
      path: "/automations/new_automation"
      fullPath: "/$datasetSlug/automations/new_automation"
      preLoaderRoute: typeof DashboardDatasetSlugAutomationsNew_automationRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/custom-ui/$id": {
      id: "/_dashboard/$datasetSlug/custom-ui/$id"
      path: "/custom-ui/$id"
      fullPath: "/$datasetSlug/custom-ui/$id"
      preLoaderRoute: typeof DashboardDatasetSlugCustomUiIdRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/applications": {
      id: "/_dashboard/$datasetSlug/data/applications"
      path: "/data/applications"
      fullPath: "/$datasetSlug/data/applications"
      preLoaderRoute: typeof DashboardDatasetSlugDataApplicationsRouteRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/docs/": {
      id: "/_dashboard/$datasetSlug/docs/"
      path: "/docs"
      fullPath: "/$datasetSlug/docs/"
      preLoaderRoute: typeof DashboardDatasetSlugDocsIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/docs/$": {
      id: "/_dashboard/$datasetSlug/docs/$"
      path: "/docs/$"
      fullPath: "/$datasetSlug/docs/$"
      preLoaderRoute: typeof DashboardDatasetSlugDocsSplatRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/library/": {
      id: "/_dashboard/$datasetSlug/library/"
      path: "/library"
      fullPath: "/$datasetSlug/library/"
      preLoaderRoute: typeof DashboardDatasetSlugLibraryIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/notes/": {
      id: "/_dashboard/$datasetSlug/notes/"
      path: "/notes"
      fullPath: "/$datasetSlug/notes/"
      preLoaderRoute: typeof DashboardDatasetSlugNotesIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/notes/create": {
      id: "/_dashboard/$datasetSlug/notes/create"
      path: "/notes/create"
      fullPath: "/$datasetSlug/notes/create"
      preLoaderRoute: typeof DashboardDatasetSlugNotesCreateRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/plugins/$id": {
      id: "/_dashboard/$datasetSlug/plugins/$id"
      path: "/plugins/$id"
      fullPath: "/$datasetSlug/plugins/$id"
      preLoaderRoute: typeof DashboardDatasetSlugPluginsIdRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/search/$entityType": {
      id: "/_dashboard/$datasetSlug/search/$entityType"
      path: "/$entityType"
      fullPath: "/$datasetSlug/search/$entityType"
      preLoaderRoute: typeof DashboardDatasetSlugSearchEntityTypeRouteImport
      parentRoute: typeof DashboardDatasetSlugSearchRoute
    }
    "/_dashboard/$datasetSlug/settings/ai-agents": {
      id: "/_dashboard/$datasetSlug/settings/ai-agents"
      path: "/ai-agents"
      fullPath: "/$datasetSlug/settings/ai-agents"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsAiAgentsRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/settings/ai-skills": {
      id: "/_dashboard/$datasetSlug/settings/ai-skills"
      path: "/ai-skills"
      fullPath: "/$datasetSlug/settings/ai-skills"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsAiSkillsRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/settings/api": {
      id: "/_dashboard/$datasetSlug/settings/api"
      path: "/api"
      fullPath: "/$datasetSlug/settings/api"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsApiRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/settings/applications": {
      id: "/_dashboard/$datasetSlug/settings/applications"
      path: "/applications"
      fullPath: "/$datasetSlug/settings/applications"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsApplicationsRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/settings/custom-ui": {
      id: "/_dashboard/$datasetSlug/settings/custom-ui"
      path: "/custom-ui"
      fullPath: "/$datasetSlug/settings/custom-ui"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsCustomUiRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/settings/files": {
      id: "/_dashboard/$datasetSlug/settings/files"
      path: "/files"
      fullPath: "/$datasetSlug/settings/files"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsFilesRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/settings/global-ai-settings": {
      id: "/_dashboard/$datasetSlug/settings/global-ai-settings"
      path: "/global-ai-settings"
      fullPath: "/$datasetSlug/settings/global-ai-settings"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsGlobalAiSettingsRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/settings/interviews": {
      id: "/_dashboard/$datasetSlug/settings/interviews"
      path: "/interviews"
      fullPath: "/$datasetSlug/settings/interviews"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsInterviewsRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/settings/live-agents": {
      id: "/_dashboard/$datasetSlug/settings/live-agents"
      path: "/live-agents"
      fullPath: "/$datasetSlug/settings/live-agents"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsLiveAgentsRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/settings/plugins": {
      id: "/_dashboard/$datasetSlug/settings/plugins"
      path: "/plugins"
      fullPath: "/$datasetSlug/settings/plugins"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsPluginsRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/settings/security": {
      id: "/_dashboard/$datasetSlug/settings/security"
      path: "/security"
      fullPath: "/$datasetSlug/settings/security"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsSecurityRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/settings/submissions": {
      id: "/_dashboard/$datasetSlug/settings/submissions"
      path: "/submissions"
      fullPath: "/$datasetSlug/settings/submissions"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsSubmissionsRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/settings/tags": {
      id: "/_dashboard/$datasetSlug/settings/tags"
      path: "/tags"
      fullPath: "/$datasetSlug/settings/tags"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsTagsRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/settings/users": {
      id: "/_dashboard/$datasetSlug/settings/users"
      path: "/users"
      fullPath: "/$datasetSlug/settings/users"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsUsersRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/support/": {
      id: "/_dashboard/$datasetSlug/support/"
      path: "/support"
      fullPath: "/$datasetSlug/support/"
      preLoaderRoute: typeof DashboardDatasetSlugSupportIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/support/$ticketId": {
      id: "/_dashboard/$datasetSlug/support/$ticketId"
      path: "/support/$ticketId"
      fullPath: "/$datasetSlug/support/$ticketId"
      preLoaderRoute: typeof DashboardDatasetSlugSupportTicketIdRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/support/new": {
      id: "/_dashboard/$datasetSlug/support/new"
      path: "/support/new"
      fullPath: "/$datasetSlug/support/new"
      preLoaderRoute: typeof DashboardDatasetSlugSupportNewRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/tasks/": {
      id: "/_dashboard/$datasetSlug/tasks/"
      path: "/tasks"
      fullPath: "/$datasetSlug/tasks/"
      preLoaderRoute: typeof DashboardDatasetSlugTasksIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/tasks/$taskId": {
      id: "/_dashboard/$datasetSlug/tasks/$taskId"
      path: "/tasks/$taskId"
      fullPath: "/$datasetSlug/tasks/$taskId"
      preLoaderRoute: typeof DashboardDatasetSlugTasksTaskIdRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/tasks/statistics": {
      id: "/_dashboard/$datasetSlug/tasks/statistics"
      path: "/tasks/statistics"
      fullPath: "/$datasetSlug/tasks/statistics"
      preLoaderRoute: typeof DashboardDatasetSlugTasksStatisticsRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/(chats)/chats/$conversationId": {
      id: "/_dashboard/$datasetSlug/(chats)/chats/$conversationId"
      path: "/$conversationId"
      fullPath: "/$datasetSlug/chats/$conversationId"
      preLoaderRoute: typeof DashboardDatasetSlugchatsChatsConversationIdRouteImport
      parentRoute: typeof DashboardDatasetSlugchatsChatsRoute
    }
    "/_dashboard/$datasetSlug/apps/installed/": {
      id: "/_dashboard/$datasetSlug/apps/installed/"
      path: "/installed"
      fullPath: "/$datasetSlug/apps/installed/"
      preLoaderRoute: typeof DashboardDatasetSlugAppsInstalledIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugAppsRoute
    }
    "/_dashboard/$datasetSlug/apps/syncs/": {
      id: "/_dashboard/$datasetSlug/apps/syncs/"
      path: "/syncs"
      fullPath: "/$datasetSlug/apps/syncs/"
      preLoaderRoute: typeof DashboardDatasetSlugAppsSyncsIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugAppsRoute
    }
    "/_dashboard/$datasetSlug/apps/syncs/$sourceId": {
      id: "/_dashboard/$datasetSlug/apps/syncs/$sourceId"
      path: "/syncs/$sourceId"
      fullPath: "/$datasetSlug/apps/syncs/$sourceId"
      preLoaderRoute: typeof DashboardDatasetSlugAppsSyncsSourceIdRouteImport
      parentRoute: typeof DashboardDatasetSlugAppsRoute
    }
    "/_dashboard/$datasetSlug/apps/syncs/writebacks": {
      id: "/_dashboard/$datasetSlug/apps/syncs/writebacks"
      path: "/syncs/writebacks"
      fullPath: "/$datasetSlug/apps/syncs/writebacks"
      preLoaderRoute: typeof DashboardDatasetSlugAppsSyncsWritebacksRouteImport
      parentRoute: typeof DashboardDatasetSlugAppsRoute
    }
    "/_dashboard/$datasetSlug/apps_/installed/$appId": {
      id: "/_dashboard/$datasetSlug/apps_/installed/$appId"
      path: "/apps/installed/$appId"
      fullPath: "/$datasetSlug/apps/installed/$appId"
      preLoaderRoute: typeof DashboardDatasetSlugAppsInstalledAppIdRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/automations/$automationId/": {
      id: "/_dashboard/$datasetSlug/automations/$automationId/"
      path: "/automations/$automationId"
      fullPath: "/$datasetSlug/automations/$automationId/"
      preLoaderRoute: typeof DashboardDatasetSlugAutomationsAutomationIdIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/automations/$automationId/builder": {
      id: "/_dashboard/$datasetSlug/automations/$automationId/builder"
      path: "/automations/$automationId/builder"
      fullPath: "/$datasetSlug/automations/$automationId/builder"
      preLoaderRoute: typeof DashboardDatasetSlugAutomationsAutomationIdBuilderRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/automations/$automationId/logs": {
      id: "/_dashboard/$datasetSlug/automations/$automationId/logs"
      path: "/automations/$automationId/logs"
      fullPath: "/$datasetSlug/automations/$automationId/logs"
      preLoaderRoute: typeof DashboardDatasetSlugAutomationsAutomationIdLogsRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/applications/activities": {
      id: "/_dashboard/$datasetSlug/data/applications/activities"
      path: "/activities"
      fullPath: "/$datasetSlug/data/applications/activities"
      preLoaderRoute: typeof DashboardDatasetSlugDataApplicationsActivitiesRouteImport
      parentRoute: typeof DashboardDatasetSlugDataApplicationsRouteRoute
    }
    "/_dashboard/$datasetSlug/data/applications/list": {
      id: "/_dashboard/$datasetSlug/data/applications/list"
      path: "/list"
      fullPath: "/$datasetSlug/data/applications/list"
      preLoaderRoute: typeof DashboardDatasetSlugDataApplicationsListRouteImport
      parentRoute: typeof DashboardDatasetSlugDataApplicationsRouteRoute
    }
    "/_dashboard/$datasetSlug/data/candidates/": {
      id: "/_dashboard/$datasetSlug/data/candidates/"
      path: "/data/candidates"
      fullPath: "/$datasetSlug/data/candidates/"
      preLoaderRoute: typeof DashboardDatasetSlugDataCandidatesIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/candidates/$candidateId": {
      id: "/_dashboard/$datasetSlug/data/candidates/$candidateId"
      path: "/data/candidates/$candidateId"
      fullPath: "/$datasetSlug/data/candidates/$candidateId"
      preLoaderRoute: typeof DashboardDatasetSlugDataCandidatesCandidateIdRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/candidates/create": {
      id: "/_dashboard/$datasetSlug/data/candidates/create"
      path: "/data/candidates/create"
      fullPath: "/$datasetSlug/data/candidates/create"
      preLoaderRoute: typeof DashboardDatasetSlugDataCandidatesCreateRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/candidates/settings": {
      id: "/_dashboard/$datasetSlug/data/candidates/settings"
      path: "/data/candidates/settings"
      fullPath: "/$datasetSlug/data/candidates/settings"
      preLoaderRoute: typeof DashboardDatasetSlugDataCandidatesSettingsRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/clients/": {
      id: "/_dashboard/$datasetSlug/data/clients/"
      path: "/data/clients"
      fullPath: "/$datasetSlug/data/clients/"
      preLoaderRoute: typeof DashboardDatasetSlugDataClientsIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/clients/$clientId": {
      id: "/_dashboard/$datasetSlug/data/clients/$clientId"
      path: "/data/clients/$clientId"
      fullPath: "/$datasetSlug/data/clients/$clientId"
      preLoaderRoute: typeof DashboardDatasetSlugDataClientsClientIdRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/clients/create": {
      id: "/_dashboard/$datasetSlug/data/clients/create"
      path: "/data/clients/create"
      fullPath: "/$datasetSlug/data/clients/create"
      preLoaderRoute: typeof DashboardDatasetSlugDataClientsCreateRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/clients/settings": {
      id: "/_dashboard/$datasetSlug/data/clients/settings"
      path: "/data/clients/settings"
      fullPath: "/$datasetSlug/data/clients/settings"
      preLoaderRoute: typeof DashboardDatasetSlugDataClientsSettingsRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/contacts/": {
      id: "/_dashboard/$datasetSlug/data/contacts/"
      path: "/data/contacts"
      fullPath: "/$datasetSlug/data/contacts/"
      preLoaderRoute: typeof DashboardDatasetSlugDataContactsIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/contacts/$contactId": {
      id: "/_dashboard/$datasetSlug/data/contacts/$contactId"
      path: "/data/contacts/$contactId"
      fullPath: "/$datasetSlug/data/contacts/$contactId"
      preLoaderRoute: typeof DashboardDatasetSlugDataContactsContactIdRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/contacts/create": {
      id: "/_dashboard/$datasetSlug/data/contacts/create"
      path: "/data/contacts/create"
      fullPath: "/$datasetSlug/data/contacts/create"
      preLoaderRoute: typeof DashboardDatasetSlugDataContactsCreateRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/contacts/settings": {
      id: "/_dashboard/$datasetSlug/data/contacts/settings"
      path: "/data/contacts/settings"
      fullPath: "/$datasetSlug/data/contacts/settings"
      preLoaderRoute: typeof DashboardDatasetSlugDataContactsSettingsRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/custom/create": {
      id: "/_dashboard/$datasetSlug/data/custom/create"
      path: "/data/custom/create"
      fullPath: "/$datasetSlug/data/custom/create"
      preLoaderRoute: typeof DashboardDatasetSlugDataCustomCreateRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/cv-sends/": {
      id: "/_dashboard/$datasetSlug/data/cv-sends/"
      path: "/data/cv-sends"
      fullPath: "/$datasetSlug/data/cv-sends/"
      preLoaderRoute: typeof DashboardDatasetSlugDataCvSendsIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/job-submissions/": {
      id: "/_dashboard/$datasetSlug/data/job-submissions/"
      path: "/data/job-submissions"
      fullPath: "/$datasetSlug/data/job-submissions/"
      preLoaderRoute: typeof DashboardDatasetSlugDataJobSubmissionsIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/jobs/": {
      id: "/_dashboard/$datasetSlug/data/jobs/"
      path: "/data/jobs"
      fullPath: "/$datasetSlug/data/jobs/"
      preLoaderRoute: typeof DashboardDatasetSlugDataJobsIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/jobs/$jobId": {
      id: "/_dashboard/$datasetSlug/data/jobs/$jobId"
      path: "/data/jobs/$jobId"
      fullPath: "/$datasetSlug/data/jobs/$jobId"
      preLoaderRoute: typeof DashboardDatasetSlugDataJobsJobIdRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/jobs/create": {
      id: "/_dashboard/$datasetSlug/data/jobs/create"
      path: "/data/jobs/create"
      fullPath: "/$datasetSlug/data/jobs/create"
      preLoaderRoute: typeof DashboardDatasetSlugDataJobsCreateRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/jobs/settings": {
      id: "/_dashboard/$datasetSlug/data/jobs/settings"
      path: "/data/jobs/settings"
      fullPath: "/$datasetSlug/data/jobs/settings"
      preLoaderRoute: typeof DashboardDatasetSlugDataJobsSettingsRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/lists/": {
      id: "/_dashboard/$datasetSlug/data/lists/"
      path: "/data/lists"
      fullPath: "/$datasetSlug/data/lists/"
      preLoaderRoute: typeof DashboardDatasetSlugDataListsIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/lists/$listId": {
      id: "/_dashboard/$datasetSlug/data/lists/$listId"
      path: "/data/lists/$listId"
      fullPath: "/$datasetSlug/data/lists/$listId"
      preLoaderRoute: typeof DashboardDatasetSlugDataListsListIdRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/placements/": {
      id: "/_dashboard/$datasetSlug/data/placements/"
      path: "/data/placements"
      fullPath: "/$datasetSlug/data/placements/"
      preLoaderRoute: typeof DashboardDatasetSlugDataPlacementsIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/placements/settings": {
      id: "/_dashboard/$datasetSlug/data/placements/settings"
      path: "/data/placements/settings"
      fullPath: "/$datasetSlug/data/placements/settings"
      preLoaderRoute: typeof DashboardDatasetSlugDataPlacementsSettingsRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/skills/": {
      id: "/_dashboard/$datasetSlug/data/skills/"
      path: "/data/skills"
      fullPath: "/$datasetSlug/data/skills/"
      preLoaderRoute: typeof DashboardDatasetSlugDataSkillsIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/skills/$skillId": {
      id: "/_dashboard/$datasetSlug/data/skills/$skillId"
      path: "/data/skills/$skillId"
      fullPath: "/$datasetSlug/data/skills/$skillId"
      preLoaderRoute: typeof DashboardDatasetSlugDataSkillsSkillIdRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/skills/review": {
      id: "/_dashboard/$datasetSlug/data/skills/review"
      path: "/data/skills/review"
      fullPath: "/$datasetSlug/data/skills/review"
      preLoaderRoute: typeof DashboardDatasetSlugDataSkillsReviewRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/skills/settings": {
      id: "/_dashboard/$datasetSlug/data/skills/settings"
      path: "/data/skills/settings"
      fullPath: "/$datasetSlug/data/skills/settings"
      preLoaderRoute: typeof DashboardDatasetSlugDataSkillsSettingsRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/notes/$id/edit": {
      id: "/_dashboard/$datasetSlug/notes/$id/edit"
      path: "/notes/$id/edit"
      fullPath: "/$datasetSlug/notes/$id/edit"
      preLoaderRoute: typeof DashboardDatasetSlugNotesIdEditRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/settings/ai-agents_/$id": {
      id: "/_dashboard/$datasetSlug/settings/ai-agents_/$id"
      path: "/ai-agents/$id"
      fullPath: "/$datasetSlug/settings/ai-agents/$id"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsAiAgentsIdRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/settings/ai-agents_/create": {
      id: "/_dashboard/$datasetSlug/settings/ai-agents_/create"
      path: "/ai-agents/create"
      fullPath: "/$datasetSlug/settings/ai-agents/create"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsAiAgentsCreateRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/settings/email-settings/": {
      id: "/_dashboard/$datasetSlug/settings/email-settings/"
      path: "/email-settings"
      fullPath: "/$datasetSlug/settings/email-settings/"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsEmailSettingsIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/settings/linked-accounts/": {
      id: "/_dashboard/$datasetSlug/settings/linked-accounts/"
      path: "/linked-accounts"
      fullPath: "/$datasetSlug/settings/linked-accounts/"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsLinkedAccountsIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/settings/live-agents_/$id": {
      id: "/_dashboard/$datasetSlug/settings/live-agents_/$id"
      path: "/live-agents/$id"
      fullPath: "/$datasetSlug/settings/live-agents/$id"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsLiveAgentsIdRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/settings/live-agents_/create": {
      id: "/_dashboard/$datasetSlug/settings/live-agents_/create"
      path: "/live-agents/create"
      fullPath: "/$datasetSlug/settings/live-agents/create"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsLiveAgentsCreateRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/settings/permissions/": {
      id: "/_dashboard/$datasetSlug/settings/permissions/"
      path: "/permissions"
      fullPath: "/$datasetSlug/settings/permissions/"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsPermissionsIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/settings/permissions/create": {
      id: "/_dashboard/$datasetSlug/settings/permissions/create"
      path: "/permissions/create"
      fullPath: "/$datasetSlug/settings/permissions/create"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsPermissionsCreateRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/settings/tags_/$id": {
      id: "/_dashboard/$datasetSlug/settings/tags_/$id"
      path: "/tags/$id"
      fullPath: "/$datasetSlug/settings/tags/$id"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsTagsIdRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/apps/syncs/$sourceId/$sourceObjectId": {
      id: "/_dashboard/$datasetSlug/apps/syncs/$sourceId/$sourceObjectId"
      path: "/$sourceObjectId"
      fullPath: "/$datasetSlug/apps/syncs/$sourceId/$sourceObjectId"
      preLoaderRoute: typeof DashboardDatasetSlugAppsSyncsSourceIdSourceObjectIdRouteImport
      parentRoute: typeof DashboardDatasetSlugAppsSyncsSourceIdRoute
    }
    "/_dashboard/$datasetSlug/automations/$automationId/logs/$journeyId": {
      id: "/_dashboard/$datasetSlug/automations/$automationId/logs/$journeyId"
      path: "/$journeyId"
      fullPath: "/$datasetSlug/automations/$automationId/logs/$journeyId"
      preLoaderRoute: typeof DashboardDatasetSlugAutomationsAutomationIdLogsJourneyIdRouteImport
      parentRoute: typeof DashboardDatasetSlugAutomationsAutomationIdLogsRoute
    }
    "/_dashboard/$datasetSlug/data/applications/list/$applicationId": {
      id: "/_dashboard/$datasetSlug/data/applications/list/$applicationId"
      path: "/$applicationId"
      fullPath: "/$datasetSlug/data/applications/list/$applicationId"
      preLoaderRoute: typeof DashboardDatasetSlugDataApplicationsListApplicationIdRouteImport
      parentRoute: typeof DashboardDatasetSlugDataApplicationsListRoute
    }
    "/_dashboard/$datasetSlug/data/applications/table/": {
      id: "/_dashboard/$datasetSlug/data/applications/table/"
      path: "/table"
      fullPath: "/$datasetSlug/data/applications/table/"
      preLoaderRoute: typeof DashboardDatasetSlugDataApplicationsTableIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugDataApplicationsRouteRoute
    }
    "/_dashboard/$datasetSlug/data/applications/table/$applicationId": {
      id: "/_dashboard/$datasetSlug/data/applications/table/$applicationId"
      path: "/table/$applicationId"
      fullPath: "/$datasetSlug/data/applications/table/$applicationId"
      preLoaderRoute: typeof DashboardDatasetSlugDataApplicationsTableApplicationIdRouteImport
      parentRoute: typeof DashboardDatasetSlugDataApplicationsRouteRoute
    }
    "/_dashboard/$datasetSlug/data/candidates/edit/$id": {
      id: "/_dashboard/$datasetSlug/data/candidates/edit/$id"
      path: "/data/candidates/edit/$id"
      fullPath: "/$datasetSlug/data/candidates/edit/$id"
      preLoaderRoute: typeof DashboardDatasetSlugDataCandidatesEditIdRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/candidates/view/$viewName": {
      id: "/_dashboard/$datasetSlug/data/candidates/view/$viewName"
      path: "/data/candidates/view/$viewName"
      fullPath: "/$datasetSlug/data/candidates/view/$viewName"
      preLoaderRoute: typeof DashboardDatasetSlugDataCandidatesViewViewNameRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/clients/edit/$id": {
      id: "/_dashboard/$datasetSlug/data/clients/edit/$id"
      path: "/data/clients/edit/$id"
      fullPath: "/$datasetSlug/data/clients/edit/$id"
      preLoaderRoute: typeof DashboardDatasetSlugDataClientsEditIdRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/clients/view/$viewName": {
      id: "/_dashboard/$datasetSlug/data/clients/view/$viewName"
      path: "/data/clients/view/$viewName"
      fullPath: "/$datasetSlug/data/clients/view/$viewName"
      preLoaderRoute: typeof DashboardDatasetSlugDataClientsViewViewNameRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/contacts/edit/$id": {
      id: "/_dashboard/$datasetSlug/data/contacts/edit/$id"
      path: "/data/contacts/edit/$id"
      fullPath: "/$datasetSlug/data/contacts/edit/$id"
      preLoaderRoute: typeof DashboardDatasetSlugDataContactsEditIdRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/contacts/view/$viewName": {
      id: "/_dashboard/$datasetSlug/data/contacts/view/$viewName"
      path: "/data/contacts/view/$viewName"
      fullPath: "/$datasetSlug/data/contacts/view/$viewName"
      preLoaderRoute: typeof DashboardDatasetSlugDataContactsViewViewNameRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/jobs/edit/$id": {
      id: "/_dashboard/$datasetSlug/data/jobs/edit/$id"
      path: "/data/jobs/edit/$id"
      fullPath: "/$datasetSlug/data/jobs/edit/$id"
      preLoaderRoute: typeof DashboardDatasetSlugDataJobsEditIdRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/jobs/view/$viewName": {
      id: "/_dashboard/$datasetSlug/data/jobs/view/$viewName"
      path: "/data/jobs/view/$viewName"
      fullPath: "/$datasetSlug/data/jobs/view/$viewName"
      preLoaderRoute: typeof DashboardDatasetSlugDataJobsViewViewNameRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/skills/sets/": {
      id: "/_dashboard/$datasetSlug/data/skills/sets/"
      path: "/data/skills/sets"
      fullPath: "/$datasetSlug/data/skills/sets/"
      preLoaderRoute: typeof DashboardDatasetSlugDataSkillsSetsIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/skills/sets/$set_id": {
      id: "/_dashboard/$datasetSlug/data/skills/sets/$set_id"
      path: "/data/skills/sets/$set_id"
      fullPath: "/$datasetSlug/data/skills/sets/$set_id"
      preLoaderRoute: typeof DashboardDatasetSlugDataSkillsSetsSet_idRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/settings/email-settings/sync-settings/": {
      id: "/_dashboard/$datasetSlug/settings/email-settings/sync-settings/"
      path: "/email-settings/sync-settings"
      fullPath: "/$datasetSlug/settings/email-settings/sync-settings/"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsEmailSettingsSyncSettingsIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/settings/email-settings/templates/": {
      id: "/_dashboard/$datasetSlug/settings/email-settings/templates/"
      path: "/email-settings/templates"
      fullPath: "/$datasetSlug/settings/email-settings/templates/"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsEmailSettingsTemplatesIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/settings/email-settings/templates/create": {
      id: "/_dashboard/$datasetSlug/settings/email-settings/templates/create"
      path: "/email-settings/templates/create"
      fullPath: "/$datasetSlug/settings/email-settings/templates/create"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsEmailSettingsTemplatesCreateRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/settings/live-agents_/$id/": {
      id: "/_dashboard/$datasetSlug/settings/live-agents_/$id/"
      path: "/"
      fullPath: "/$datasetSlug/settings/live-agents/$id/"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsLiveAgentsIdIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsLiveAgentsIdRoute
    }
    "/_dashboard/$datasetSlug/settings/live-agents_/$id/edit": {
      id: "/_dashboard/$datasetSlug/settings/live-agents_/$id/edit"
      path: "/edit"
      fullPath: "/$datasetSlug/settings/live-agents/$id/edit"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsLiveAgentsIdEditRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsLiveAgentsIdRoute
    }
    "/_dashboard/$datasetSlug/settings/live-agents_/$id/runs": {
      id: "/_dashboard/$datasetSlug/settings/live-agents_/$id/runs"
      path: "/runs"
      fullPath: "/$datasetSlug/settings/live-agents/$id/runs"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsLiveAgentsIdRunsRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsLiveAgentsIdRoute
    }
    "/_dashboard/$datasetSlug/settings/permissions/edit/$id": {
      id: "/_dashboard/$datasetSlug/settings/permissions/edit/$id"
      path: "/permissions/edit/$id"
      fullPath: "/$datasetSlug/settings/permissions/edit/$id"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsPermissionsEditIdRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/settings/users/$id/edit": {
      id: "/_dashboard/$datasetSlug/settings/users/$id/edit"
      path: "/$id/edit"
      fullPath: "/$datasetSlug/settings/users/$id/edit"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsUsersIdEditRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsUsersRoute
    }
    "/_dashboard/$datasetSlug/(chats)/chats_/$conversationId/searches/$searchId": {
      id: "/_dashboard/$datasetSlug/(chats)/chats_/$conversationId/searches/$searchId"
      path: "/chats/$conversationId/searches/$searchId"
      fullPath: "/$datasetSlug/chats/$conversationId/searches/$searchId"
      preLoaderRoute: typeof DashboardDatasetSlugchatsChatsConversationIdSearchesSearchIdRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/custom/details/$id/create": {
      id: "/_dashboard/$datasetSlug/data/custom/details/$id/create"
      path: "/data/custom/details/$id/create"
      fullPath: "/$datasetSlug/data/custom/details/$id/create"
      preLoaderRoute: typeof DashboardDatasetSlugDataCustomDetailsIdCreateRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/custom/details/$id/kanban": {
      id: "/_dashboard/$datasetSlug/data/custom/details/$id/kanban"
      path: "/data/custom/details/$id/kanban"
      fullPath: "/$datasetSlug/data/custom/details/$id/kanban"
      preLoaderRoute: typeof DashboardDatasetSlugDataCustomDetailsIdKanbanRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/custom/details/$id/settings": {
      id: "/_dashboard/$datasetSlug/data/custom/details/$id/settings"
      path: "/data/custom/details/$id/settings"
      fullPath: "/$datasetSlug/data/custom/details/$id/settings"
      preLoaderRoute: typeof DashboardDatasetSlugDataCustomDetailsIdSettingsRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/settings/email-settings/templates/edit/$id": {
      id: "/_dashboard/$datasetSlug/settings/email-settings/templates/edit/$id"
      path: "/email-settings/templates/edit/$id"
      fullPath: "/$datasetSlug/settings/email-settings/templates/edit/$id"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsEmailSettingsTemplatesEditIdRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsRouteRoute
    }
    "/_dashboard/$datasetSlug/settings/live-agents_/$id/runs/": {
      id: "/_dashboard/$datasetSlug/settings/live-agents_/$id/runs/"
      path: "/"
      fullPath: "/$datasetSlug/settings/live-agents/$id/runs/"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsLiveAgentsIdRunsIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsLiveAgentsIdRunsRoute
    }
    "/_dashboard/$datasetSlug/settings/live-agents_/$id/runs/$runId": {
      id: "/_dashboard/$datasetSlug/settings/live-agents_/$id/runs/$runId"
      path: "/$runId"
      fullPath: "/$datasetSlug/settings/live-agents/$id/runs/$runId"
      preLoaderRoute: typeof DashboardDatasetSlugSettingsLiveAgentsIdRunsRunIdRouteImport
      parentRoute: typeof DashboardDatasetSlugSettingsLiveAgentsIdRunsRoute
    }
    "/_dashboard/$datasetSlug/data/custom/details/$id/edit/$rowId": {
      id: "/_dashboard/$datasetSlug/data/custom/details/$id/edit/$rowId"
      path: "/data/custom/details/$id/edit/$rowId"
      fullPath: "/$datasetSlug/data/custom/details/$id/edit/$rowId"
      preLoaderRoute: typeof DashboardDatasetSlugDataCustomDetailsIdEditRowIdRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/custom/details/$id/table/": {
      id: "/_dashboard/$datasetSlug/data/custom/details/$id/table/"
      path: "/data/custom/details/$id/table"
      fullPath: "/$datasetSlug/data/custom/details/$id/table/"
      preLoaderRoute: typeof DashboardDatasetSlugDataCustomDetailsIdTableIndexRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/custom/details/$id/table/$customDetailsId": {
      id: "/_dashboard/$datasetSlug/data/custom/details/$id/table/$customDetailsId"
      path: "/data/custom/details/$id/table/$customDetailsId"
      fullPath: "/$datasetSlug/data/custom/details/$id/table/$customDetailsId"
      preLoaderRoute: typeof DashboardDatasetSlugDataCustomDetailsIdTableCustomDetailsIdRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
    "/_dashboard/$datasetSlug/data/custom/details/$id/view/$viewName": {
      id: "/_dashboard/$datasetSlug/data/custom/details/$id/view/$viewName"
      path: "/data/custom/details/$id/view/$viewName"
      fullPath: "/$datasetSlug/data/custom/details/$id/view/$viewName"
      preLoaderRoute: typeof DashboardDatasetSlugDataCustomDetailsIdViewViewNameRouteImport
      parentRoute: typeof DashboardDatasetSlugRoute
    }
  }
}

interface DashboardDatasetSlugSettingsUsersRouteChildren {
  DashboardDatasetSlugSettingsUsersIdEditRoute: typeof DashboardDatasetSlugSettingsUsersIdEditRoute
}

const DashboardDatasetSlugSettingsUsersRouteChildren: DashboardDatasetSlugSettingsUsersRouteChildren =
  {
    DashboardDatasetSlugSettingsUsersIdEditRoute:
      DashboardDatasetSlugSettingsUsersIdEditRoute,
  }

const DashboardDatasetSlugSettingsUsersRouteWithChildren =
  DashboardDatasetSlugSettingsUsersRoute._addFileChildren(
    DashboardDatasetSlugSettingsUsersRouteChildren,
  )

interface DashboardDatasetSlugSettingsLiveAgentsIdRunsRouteChildren {
  DashboardDatasetSlugSettingsLiveAgentsIdRunsRunIdRoute: typeof DashboardDatasetSlugSettingsLiveAgentsIdRunsRunIdRoute
  DashboardDatasetSlugSettingsLiveAgentsIdRunsIndexRoute: typeof DashboardDatasetSlugSettingsLiveAgentsIdRunsIndexRoute
}

const DashboardDatasetSlugSettingsLiveAgentsIdRunsRouteChildren: DashboardDatasetSlugSettingsLiveAgentsIdRunsRouteChildren =
  {
    DashboardDatasetSlugSettingsLiveAgentsIdRunsRunIdRoute:
      DashboardDatasetSlugSettingsLiveAgentsIdRunsRunIdRoute,
    DashboardDatasetSlugSettingsLiveAgentsIdRunsIndexRoute:
      DashboardDatasetSlugSettingsLiveAgentsIdRunsIndexRoute,
  }

const DashboardDatasetSlugSettingsLiveAgentsIdRunsRouteWithChildren =
  DashboardDatasetSlugSettingsLiveAgentsIdRunsRoute._addFileChildren(
    DashboardDatasetSlugSettingsLiveAgentsIdRunsRouteChildren,
  )

interface DashboardDatasetSlugSettingsLiveAgentsIdRouteChildren {
  DashboardDatasetSlugSettingsLiveAgentsIdEditRoute: typeof DashboardDatasetSlugSettingsLiveAgentsIdEditRoute
  DashboardDatasetSlugSettingsLiveAgentsIdRunsRoute: typeof DashboardDatasetSlugSettingsLiveAgentsIdRunsRouteWithChildren
  DashboardDatasetSlugSettingsLiveAgentsIdIndexRoute: typeof DashboardDatasetSlugSettingsLiveAgentsIdIndexRoute
}

const DashboardDatasetSlugSettingsLiveAgentsIdRouteChildren: DashboardDatasetSlugSettingsLiveAgentsIdRouteChildren =
  {
    DashboardDatasetSlugSettingsLiveAgentsIdEditRoute:
      DashboardDatasetSlugSettingsLiveAgentsIdEditRoute,
    DashboardDatasetSlugSettingsLiveAgentsIdRunsRoute:
      DashboardDatasetSlugSettingsLiveAgentsIdRunsRouteWithChildren,
    DashboardDatasetSlugSettingsLiveAgentsIdIndexRoute:
      DashboardDatasetSlugSettingsLiveAgentsIdIndexRoute,
  }

const DashboardDatasetSlugSettingsLiveAgentsIdRouteWithChildren =
  DashboardDatasetSlugSettingsLiveAgentsIdRoute._addFileChildren(
    DashboardDatasetSlugSettingsLiveAgentsIdRouteChildren,
  )

interface DashboardDatasetSlugSettingsRouteRouteChildren {
  DashboardDatasetSlugSettingsAiAgentsRoute: typeof DashboardDatasetSlugSettingsAiAgentsRoute
  DashboardDatasetSlugSettingsAiSkillsRoute: typeof DashboardDatasetSlugSettingsAiSkillsRoute
  DashboardDatasetSlugSettingsApiRoute: typeof DashboardDatasetSlugSettingsApiRoute
  DashboardDatasetSlugSettingsApplicationsRoute: typeof DashboardDatasetSlugSettingsApplicationsRoute
  DashboardDatasetSlugSettingsCustomUiRoute: typeof DashboardDatasetSlugSettingsCustomUiRoute
  DashboardDatasetSlugSettingsFilesRoute: typeof DashboardDatasetSlugSettingsFilesRoute
  DashboardDatasetSlugSettingsGlobalAiSettingsRoute: typeof DashboardDatasetSlugSettingsGlobalAiSettingsRoute
  DashboardDatasetSlugSettingsInterviewsRoute: typeof DashboardDatasetSlugSettingsInterviewsRoute
  DashboardDatasetSlugSettingsLiveAgentsRoute: typeof DashboardDatasetSlugSettingsLiveAgentsRoute
  DashboardDatasetSlugSettingsPluginsRoute: typeof DashboardDatasetSlugSettingsPluginsRoute
  DashboardDatasetSlugSettingsSecurityRoute: typeof DashboardDatasetSlugSettingsSecurityRoute
  DashboardDatasetSlugSettingsSubmissionsRoute: typeof DashboardDatasetSlugSettingsSubmissionsRoute
  DashboardDatasetSlugSettingsTagsRoute: typeof DashboardDatasetSlugSettingsTagsRoute
  DashboardDatasetSlugSettingsUsersRoute: typeof DashboardDatasetSlugSettingsUsersRouteWithChildren
  DashboardDatasetSlugSettingsAiAgentsIdRoute: typeof DashboardDatasetSlugSettingsAiAgentsIdRoute
  DashboardDatasetSlugSettingsAiAgentsCreateRoute: typeof DashboardDatasetSlugSettingsAiAgentsCreateRoute
  DashboardDatasetSlugSettingsLiveAgentsIdRoute: typeof DashboardDatasetSlugSettingsLiveAgentsIdRouteWithChildren
  DashboardDatasetSlugSettingsLiveAgentsCreateRoute: typeof DashboardDatasetSlugSettingsLiveAgentsCreateRoute
  DashboardDatasetSlugSettingsPermissionsCreateRoute: typeof DashboardDatasetSlugSettingsPermissionsCreateRoute
  DashboardDatasetSlugSettingsTagsIdRoute: typeof DashboardDatasetSlugSettingsTagsIdRoute
  DashboardDatasetSlugSettingsEmailSettingsIndexRoute: typeof DashboardDatasetSlugSettingsEmailSettingsIndexRoute
  DashboardDatasetSlugSettingsLinkedAccountsIndexRoute: typeof DashboardDatasetSlugSettingsLinkedAccountsIndexRoute
  DashboardDatasetSlugSettingsPermissionsIndexRoute: typeof DashboardDatasetSlugSettingsPermissionsIndexRoute
  DashboardDatasetSlugSettingsEmailSettingsTemplatesCreateRoute: typeof DashboardDatasetSlugSettingsEmailSettingsTemplatesCreateRoute
  DashboardDatasetSlugSettingsPermissionsEditIdRoute: typeof DashboardDatasetSlugSettingsPermissionsEditIdRoute
  DashboardDatasetSlugSettingsEmailSettingsSyncSettingsIndexRoute: typeof DashboardDatasetSlugSettingsEmailSettingsSyncSettingsIndexRoute
  DashboardDatasetSlugSettingsEmailSettingsTemplatesIndexRoute: typeof DashboardDatasetSlugSettingsEmailSettingsTemplatesIndexRoute
  DashboardDatasetSlugSettingsEmailSettingsTemplatesEditIdRoute: typeof DashboardDatasetSlugSettingsEmailSettingsTemplatesEditIdRoute
}

const DashboardDatasetSlugSettingsRouteRouteChildren: DashboardDatasetSlugSettingsRouteRouteChildren =
  {
    DashboardDatasetSlugSettingsAiAgentsRoute:
      DashboardDatasetSlugSettingsAiAgentsRoute,
    DashboardDatasetSlugSettingsAiSkillsRoute:
      DashboardDatasetSlugSettingsAiSkillsRoute,
    DashboardDatasetSlugSettingsApiRoute: DashboardDatasetSlugSettingsApiRoute,
    DashboardDatasetSlugSettingsApplicationsRoute:
      DashboardDatasetSlugSettingsApplicationsRoute,
    DashboardDatasetSlugSettingsCustomUiRoute:
      DashboardDatasetSlugSettingsCustomUiRoute,
    DashboardDatasetSlugSettingsFilesRoute:
      DashboardDatasetSlugSettingsFilesRoute,
    DashboardDatasetSlugSettingsGlobalAiSettingsRoute:
      DashboardDatasetSlugSettingsGlobalAiSettingsRoute,
    DashboardDatasetSlugSettingsInterviewsRoute:
      DashboardDatasetSlugSettingsInterviewsRoute,
    DashboardDatasetSlugSettingsLiveAgentsRoute:
      DashboardDatasetSlugSettingsLiveAgentsRoute,
    DashboardDatasetSlugSettingsPluginsRoute:
      DashboardDatasetSlugSettingsPluginsRoute,
    DashboardDatasetSlugSettingsSecurityRoute:
      DashboardDatasetSlugSettingsSecurityRoute,
    DashboardDatasetSlugSettingsSubmissionsRoute:
      DashboardDatasetSlugSettingsSubmissionsRoute,
    DashboardDatasetSlugSettingsTagsRoute:
      DashboardDatasetSlugSettingsTagsRoute,
    DashboardDatasetSlugSettingsUsersRoute:
      DashboardDatasetSlugSettingsUsersRouteWithChildren,
    DashboardDatasetSlugSettingsAiAgentsIdRoute:
      DashboardDatasetSlugSettingsAiAgentsIdRoute,
    DashboardDatasetSlugSettingsAiAgentsCreateRoute:
      DashboardDatasetSlugSettingsAiAgentsCreateRoute,
    DashboardDatasetSlugSettingsLiveAgentsIdRoute:
      DashboardDatasetSlugSettingsLiveAgentsIdRouteWithChildren,
    DashboardDatasetSlugSettingsLiveAgentsCreateRoute:
      DashboardDatasetSlugSettingsLiveAgentsCreateRoute,
    DashboardDatasetSlugSettingsPermissionsCreateRoute:
      DashboardDatasetSlugSettingsPermissionsCreateRoute,
    DashboardDatasetSlugSettingsTagsIdRoute:
      DashboardDatasetSlugSettingsTagsIdRoute,
    DashboardDatasetSlugSettingsEmailSettingsIndexRoute:
      DashboardDatasetSlugSettingsEmailSettingsIndexRoute,
    DashboardDatasetSlugSettingsLinkedAccountsIndexRoute:
      DashboardDatasetSlugSettingsLinkedAccountsIndexRoute,
    DashboardDatasetSlugSettingsPermissionsIndexRoute:
      DashboardDatasetSlugSettingsPermissionsIndexRoute,
    DashboardDatasetSlugSettingsEmailSettingsTemplatesCreateRoute:
      DashboardDatasetSlugSettingsEmailSettingsTemplatesCreateRoute,
    DashboardDatasetSlugSettingsPermissionsEditIdRoute:
      DashboardDatasetSlugSettingsPermissionsEditIdRoute,
    DashboardDatasetSlugSettingsEmailSettingsSyncSettingsIndexRoute:
      DashboardDatasetSlugSettingsEmailSettingsSyncSettingsIndexRoute,
    DashboardDatasetSlugSettingsEmailSettingsTemplatesIndexRoute:
      DashboardDatasetSlugSettingsEmailSettingsTemplatesIndexRoute,
    DashboardDatasetSlugSettingsEmailSettingsTemplatesEditIdRoute:
      DashboardDatasetSlugSettingsEmailSettingsTemplatesEditIdRoute,
  }

const DashboardDatasetSlugSettingsRouteRouteWithChildren =
  DashboardDatasetSlugSettingsRouteRoute._addFileChildren(
    DashboardDatasetSlugSettingsRouteRouteChildren,
  )

interface DashboardDatasetSlugAppsSyncsSourceIdRouteChildren {
  DashboardDatasetSlugAppsSyncsSourceIdSourceObjectIdRoute: typeof DashboardDatasetSlugAppsSyncsSourceIdSourceObjectIdRoute
}

const DashboardDatasetSlugAppsSyncsSourceIdRouteChildren: DashboardDatasetSlugAppsSyncsSourceIdRouteChildren =
  {
    DashboardDatasetSlugAppsSyncsSourceIdSourceObjectIdRoute:
      DashboardDatasetSlugAppsSyncsSourceIdSourceObjectIdRoute,
  }

const DashboardDatasetSlugAppsSyncsSourceIdRouteWithChildren =
  DashboardDatasetSlugAppsSyncsSourceIdRoute._addFileChildren(
    DashboardDatasetSlugAppsSyncsSourceIdRouteChildren,
  )

interface DashboardDatasetSlugAppsRouteChildren {
  DashboardDatasetSlugAppsSlugRoute: typeof DashboardDatasetSlugAppsSlugRoute
  DashboardDatasetSlugAppsIndexRoute: typeof DashboardDatasetSlugAppsIndexRoute
  DashboardDatasetSlugAppsSyncsSourceIdRoute: typeof DashboardDatasetSlugAppsSyncsSourceIdRouteWithChildren
  DashboardDatasetSlugAppsSyncsWritebacksRoute: typeof DashboardDatasetSlugAppsSyncsWritebacksRoute
  DashboardDatasetSlugAppsInstalledIndexRoute: typeof DashboardDatasetSlugAppsInstalledIndexRoute
  DashboardDatasetSlugAppsSyncsIndexRoute: typeof DashboardDatasetSlugAppsSyncsIndexRoute
}

const DashboardDatasetSlugAppsRouteChildren: DashboardDatasetSlugAppsRouteChildren =
  {
    DashboardDatasetSlugAppsSlugRoute: DashboardDatasetSlugAppsSlugRoute,
    DashboardDatasetSlugAppsIndexRoute: DashboardDatasetSlugAppsIndexRoute,
    DashboardDatasetSlugAppsSyncsSourceIdRoute:
      DashboardDatasetSlugAppsSyncsSourceIdRouteWithChildren,
    DashboardDatasetSlugAppsSyncsWritebacksRoute:
      DashboardDatasetSlugAppsSyncsWritebacksRoute,
    DashboardDatasetSlugAppsInstalledIndexRoute:
      DashboardDatasetSlugAppsInstalledIndexRoute,
    DashboardDatasetSlugAppsSyncsIndexRoute:
      DashboardDatasetSlugAppsSyncsIndexRoute,
  }

const DashboardDatasetSlugAppsRouteWithChildren =
  DashboardDatasetSlugAppsRoute._addFileChildren(
    DashboardDatasetSlugAppsRouteChildren,
  )

interface DashboardDatasetSlugSearchRouteChildren {
  DashboardDatasetSlugSearchEntityTypeRoute: typeof DashboardDatasetSlugSearchEntityTypeRoute
}

const DashboardDatasetSlugSearchRouteChildren: DashboardDatasetSlugSearchRouteChildren =
  {
    DashboardDatasetSlugSearchEntityTypeRoute:
      DashboardDatasetSlugSearchEntityTypeRoute,
  }

const DashboardDatasetSlugSearchRouteWithChildren =
  DashboardDatasetSlugSearchRoute._addFileChildren(
    DashboardDatasetSlugSearchRouteChildren,
  )

interface DashboardDatasetSlugDataApplicationsListRouteChildren {
  DashboardDatasetSlugDataApplicationsListApplicationIdRoute: typeof DashboardDatasetSlugDataApplicationsListApplicationIdRoute
}

const DashboardDatasetSlugDataApplicationsListRouteChildren: DashboardDatasetSlugDataApplicationsListRouteChildren =
  {
    DashboardDatasetSlugDataApplicationsListApplicationIdRoute:
      DashboardDatasetSlugDataApplicationsListApplicationIdRoute,
  }

const DashboardDatasetSlugDataApplicationsListRouteWithChildren =
  DashboardDatasetSlugDataApplicationsListRoute._addFileChildren(
    DashboardDatasetSlugDataApplicationsListRouteChildren,
  )

interface DashboardDatasetSlugDataApplicationsRouteRouteChildren {
  DashboardDatasetSlugDataApplicationsActivitiesRoute: typeof DashboardDatasetSlugDataApplicationsActivitiesRoute
  DashboardDatasetSlugDataApplicationsListRoute: typeof DashboardDatasetSlugDataApplicationsListRouteWithChildren
  DashboardDatasetSlugDataApplicationsTableApplicationIdRoute: typeof DashboardDatasetSlugDataApplicationsTableApplicationIdRoute
  DashboardDatasetSlugDataApplicationsTableIndexRoute: typeof DashboardDatasetSlugDataApplicationsTableIndexRoute
}

const DashboardDatasetSlugDataApplicationsRouteRouteChildren: DashboardDatasetSlugDataApplicationsRouteRouteChildren =
  {
    DashboardDatasetSlugDataApplicationsActivitiesRoute:
      DashboardDatasetSlugDataApplicationsActivitiesRoute,
    DashboardDatasetSlugDataApplicationsListRoute:
      DashboardDatasetSlugDataApplicationsListRouteWithChildren,
    DashboardDatasetSlugDataApplicationsTableApplicationIdRoute:
      DashboardDatasetSlugDataApplicationsTableApplicationIdRoute,
    DashboardDatasetSlugDataApplicationsTableIndexRoute:
      DashboardDatasetSlugDataApplicationsTableIndexRoute,
  }

const DashboardDatasetSlugDataApplicationsRouteRouteWithChildren =
  DashboardDatasetSlugDataApplicationsRouteRoute._addFileChildren(
    DashboardDatasetSlugDataApplicationsRouteRouteChildren,
  )

interface DashboardDatasetSlugchatsChatsRouteChildren {
  DashboardDatasetSlugchatsChatsConversationIdRoute: typeof DashboardDatasetSlugchatsChatsConversationIdRoute
}

const DashboardDatasetSlugchatsChatsRouteChildren: DashboardDatasetSlugchatsChatsRouteChildren =
  {
    DashboardDatasetSlugchatsChatsConversationIdRoute:
      DashboardDatasetSlugchatsChatsConversationIdRoute,
  }

const DashboardDatasetSlugchatsChatsRouteWithChildren =
  DashboardDatasetSlugchatsChatsRoute._addFileChildren(
    DashboardDatasetSlugchatsChatsRouteChildren,
  )

interface DashboardDatasetSlugAutomationsAutomationIdLogsRouteChildren {
  DashboardDatasetSlugAutomationsAutomationIdLogsJourneyIdRoute: typeof DashboardDatasetSlugAutomationsAutomationIdLogsJourneyIdRoute
}

const DashboardDatasetSlugAutomationsAutomationIdLogsRouteChildren: DashboardDatasetSlugAutomationsAutomationIdLogsRouteChildren =
  {
    DashboardDatasetSlugAutomationsAutomationIdLogsJourneyIdRoute:
      DashboardDatasetSlugAutomationsAutomationIdLogsJourneyIdRoute,
  }

const DashboardDatasetSlugAutomationsAutomationIdLogsRouteWithChildren =
  DashboardDatasetSlugAutomationsAutomationIdLogsRoute._addFileChildren(
    DashboardDatasetSlugAutomationsAutomationIdLogsRouteChildren,
  )

interface DashboardDatasetSlugRouteChildren {
  DashboardDatasetSlugSettingsRouteRoute: typeof DashboardDatasetSlugSettingsRouteRouteWithChildren
  DashboardDatasetSlugAppsRoute: typeof DashboardDatasetSlugAppsRouteWithChildren
  DashboardDatasetSlugComplianceRoute: typeof DashboardDatasetSlugComplianceRoute
  DashboardDatasetSlugDashboardRoute: typeof DashboardDatasetSlugDashboardRoute
  DashboardDatasetSlugProfileRoute: typeof DashboardDatasetSlugProfileRoute
  DashboardDatasetSlugSearchRoute: typeof DashboardDatasetSlugSearchRouteWithChildren
  DashboardDatasetSlugDataApplicationsRouteRoute: typeof DashboardDatasetSlugDataApplicationsRouteRouteWithChildren
  DashboardDatasetSlugchatsChatsRoute: typeof DashboardDatasetSlugchatsChatsRouteWithChildren
  DashboardDatasetSlugAutomationsNew_automationRoute: typeof DashboardDatasetSlugAutomationsNew_automationRoute
  DashboardDatasetSlugCustomUiIdRoute: typeof DashboardDatasetSlugCustomUiIdRoute
  DashboardDatasetSlugDocsSplatRoute: typeof DashboardDatasetSlugDocsSplatRoute
  DashboardDatasetSlugNotesCreateRoute: typeof DashboardDatasetSlugNotesCreateRoute
  DashboardDatasetSlugPluginsIdRoute: typeof DashboardDatasetSlugPluginsIdRoute
  DashboardDatasetSlugSupportTicketIdRoute: typeof DashboardDatasetSlugSupportTicketIdRoute
  DashboardDatasetSlugSupportNewRoute: typeof DashboardDatasetSlugSupportNewRoute
  DashboardDatasetSlugTasksTaskIdRoute: typeof DashboardDatasetSlugTasksTaskIdRoute
  DashboardDatasetSlugTasksStatisticsRoute: typeof DashboardDatasetSlugTasksStatisticsRoute
  DashboardDatasetSlugAutomationsIndexRoute: typeof DashboardDatasetSlugAutomationsIndexRoute
  DashboardDatasetSlugDocsIndexRoute: typeof DashboardDatasetSlugDocsIndexRoute
  DashboardDatasetSlugLibraryIndexRoute: typeof DashboardDatasetSlugLibraryIndexRoute
  DashboardDatasetSlugNotesIndexRoute: typeof DashboardDatasetSlugNotesIndexRoute
  DashboardDatasetSlugSupportIndexRoute: typeof DashboardDatasetSlugSupportIndexRoute
  DashboardDatasetSlugTasksIndexRoute: typeof DashboardDatasetSlugTasksIndexRoute
  DashboardDatasetSlugAppsInstalledAppIdRoute: typeof DashboardDatasetSlugAppsInstalledAppIdRoute
  DashboardDatasetSlugAutomationsAutomationIdBuilderRoute: typeof DashboardDatasetSlugAutomationsAutomationIdBuilderRoute
  DashboardDatasetSlugAutomationsAutomationIdLogsRoute: typeof DashboardDatasetSlugAutomationsAutomationIdLogsRouteWithChildren
  DashboardDatasetSlugDataCandidatesCandidateIdRoute: typeof DashboardDatasetSlugDataCandidatesCandidateIdRoute
  DashboardDatasetSlugDataCandidatesCreateRoute: typeof DashboardDatasetSlugDataCandidatesCreateRoute
  DashboardDatasetSlugDataCandidatesSettingsRoute: typeof DashboardDatasetSlugDataCandidatesSettingsRoute
  DashboardDatasetSlugDataClientsClientIdRoute: typeof DashboardDatasetSlugDataClientsClientIdRoute
  DashboardDatasetSlugDataClientsCreateRoute: typeof DashboardDatasetSlugDataClientsCreateRoute
  DashboardDatasetSlugDataClientsSettingsRoute: typeof DashboardDatasetSlugDataClientsSettingsRoute
  DashboardDatasetSlugDataContactsContactIdRoute: typeof DashboardDatasetSlugDataContactsContactIdRoute
  DashboardDatasetSlugDataContactsCreateRoute: typeof DashboardDatasetSlugDataContactsCreateRoute
  DashboardDatasetSlugDataContactsSettingsRoute: typeof DashboardDatasetSlugDataContactsSettingsRoute
  DashboardDatasetSlugDataCustomCreateRoute: typeof DashboardDatasetSlugDataCustomCreateRoute
  DashboardDatasetSlugDataJobsJobIdRoute: typeof DashboardDatasetSlugDataJobsJobIdRoute
  DashboardDatasetSlugDataJobsCreateRoute: typeof DashboardDatasetSlugDataJobsCreateRoute
  DashboardDatasetSlugDataJobsSettingsRoute: typeof DashboardDatasetSlugDataJobsSettingsRoute
  DashboardDatasetSlugDataListsListIdRoute: typeof DashboardDatasetSlugDataListsListIdRoute
  DashboardDatasetSlugDataPlacementsSettingsRoute: typeof DashboardDatasetSlugDataPlacementsSettingsRoute
  DashboardDatasetSlugDataSkillsSkillIdRoute: typeof DashboardDatasetSlugDataSkillsSkillIdRoute
  DashboardDatasetSlugDataSkillsReviewRoute: typeof DashboardDatasetSlugDataSkillsReviewRoute
  DashboardDatasetSlugDataSkillsSettingsRoute: typeof DashboardDatasetSlugDataSkillsSettingsRoute
  DashboardDatasetSlugNotesIdEditRoute: typeof DashboardDatasetSlugNotesIdEditRoute
  DashboardDatasetSlugAutomationsAutomationIdIndexRoute: typeof DashboardDatasetSlugAutomationsAutomationIdIndexRoute
  DashboardDatasetSlugDataCandidatesIndexRoute: typeof DashboardDatasetSlugDataCandidatesIndexRoute
  DashboardDatasetSlugDataClientsIndexRoute: typeof DashboardDatasetSlugDataClientsIndexRoute
  DashboardDatasetSlugDataContactsIndexRoute: typeof DashboardDatasetSlugDataContactsIndexRoute
  DashboardDatasetSlugDataCvSendsIndexRoute: typeof DashboardDatasetSlugDataCvSendsIndexRoute
  DashboardDatasetSlugDataJobSubmissionsIndexRoute: typeof DashboardDatasetSlugDataJobSubmissionsIndexRoute
  DashboardDatasetSlugDataJobsIndexRoute: typeof DashboardDatasetSlugDataJobsIndexRoute
  DashboardDatasetSlugDataListsIndexRoute: typeof DashboardDatasetSlugDataListsIndexRoute
  DashboardDatasetSlugDataPlacementsIndexRoute: typeof DashboardDatasetSlugDataPlacementsIndexRoute
  DashboardDatasetSlugDataSkillsIndexRoute: typeof DashboardDatasetSlugDataSkillsIndexRoute
  DashboardDatasetSlugDataCandidatesEditIdRoute: typeof DashboardDatasetSlugDataCandidatesEditIdRoute
  DashboardDatasetSlugDataCandidatesViewViewNameRoute: typeof DashboardDatasetSlugDataCandidatesViewViewNameRoute
  DashboardDatasetSlugDataClientsEditIdRoute: typeof DashboardDatasetSlugDataClientsEditIdRoute
  DashboardDatasetSlugDataClientsViewViewNameRoute: typeof DashboardDatasetSlugDataClientsViewViewNameRoute
  DashboardDatasetSlugDataContactsEditIdRoute: typeof DashboardDatasetSlugDataContactsEditIdRoute
  DashboardDatasetSlugDataContactsViewViewNameRoute: typeof DashboardDatasetSlugDataContactsViewViewNameRoute
  DashboardDatasetSlugDataJobsEditIdRoute: typeof DashboardDatasetSlugDataJobsEditIdRoute
  DashboardDatasetSlugDataJobsViewViewNameRoute: typeof DashboardDatasetSlugDataJobsViewViewNameRoute
  DashboardDatasetSlugDataSkillsSetsSet_idRoute: typeof DashboardDatasetSlugDataSkillsSetsSet_idRoute
  DashboardDatasetSlugDataSkillsSetsIndexRoute: typeof DashboardDatasetSlugDataSkillsSetsIndexRoute
  DashboardDatasetSlugchatsChatsConversationIdSearchesSearchIdRoute: typeof DashboardDatasetSlugchatsChatsConversationIdSearchesSearchIdRoute
  DashboardDatasetSlugDataCustomDetailsIdCreateRoute: typeof DashboardDatasetSlugDataCustomDetailsIdCreateRoute
  DashboardDatasetSlugDataCustomDetailsIdKanbanRoute: typeof DashboardDatasetSlugDataCustomDetailsIdKanbanRoute
  DashboardDatasetSlugDataCustomDetailsIdSettingsRoute: typeof DashboardDatasetSlugDataCustomDetailsIdSettingsRoute
  DashboardDatasetSlugDataCustomDetailsIdEditRowIdRoute: typeof DashboardDatasetSlugDataCustomDetailsIdEditRowIdRoute
  DashboardDatasetSlugDataCustomDetailsIdTableCustomDetailsIdRoute: typeof DashboardDatasetSlugDataCustomDetailsIdTableCustomDetailsIdRoute
  DashboardDatasetSlugDataCustomDetailsIdViewViewNameRoute: typeof DashboardDatasetSlugDataCustomDetailsIdViewViewNameRoute
  DashboardDatasetSlugDataCustomDetailsIdTableIndexRoute: typeof DashboardDatasetSlugDataCustomDetailsIdTableIndexRoute
}

const DashboardDatasetSlugRouteChildren: DashboardDatasetSlugRouteChildren = {
  DashboardDatasetSlugSettingsRouteRoute:
    DashboardDatasetSlugSettingsRouteRouteWithChildren,
  DashboardDatasetSlugAppsRoute: DashboardDatasetSlugAppsRouteWithChildren,
  DashboardDatasetSlugComplianceRoute: DashboardDatasetSlugComplianceRoute,
  DashboardDatasetSlugDashboardRoute: DashboardDatasetSlugDashboardRoute,
  DashboardDatasetSlugProfileRoute: DashboardDatasetSlugProfileRoute,
  DashboardDatasetSlugSearchRoute: DashboardDatasetSlugSearchRouteWithChildren,
  DashboardDatasetSlugDataApplicationsRouteRoute:
    DashboardDatasetSlugDataApplicationsRouteRouteWithChildren,
  DashboardDatasetSlugchatsChatsRoute:
    DashboardDatasetSlugchatsChatsRouteWithChildren,
  DashboardDatasetSlugAutomationsNew_automationRoute:
    DashboardDatasetSlugAutomationsNew_automationRoute,
  DashboardDatasetSlugCustomUiIdRoute: DashboardDatasetSlugCustomUiIdRoute,
  DashboardDatasetSlugDocsSplatRoute: DashboardDatasetSlugDocsSplatRoute,
  DashboardDatasetSlugNotesCreateRoute: DashboardDatasetSlugNotesCreateRoute,
  DashboardDatasetSlugPluginsIdRoute: DashboardDatasetSlugPluginsIdRoute,
  DashboardDatasetSlugSupportTicketIdRoute:
    DashboardDatasetSlugSupportTicketIdRoute,
  DashboardDatasetSlugSupportNewRoute: DashboardDatasetSlugSupportNewRoute,
  DashboardDatasetSlugTasksTaskIdRoute: DashboardDatasetSlugTasksTaskIdRoute,
  DashboardDatasetSlugTasksStatisticsRoute:
    DashboardDatasetSlugTasksStatisticsRoute,
  DashboardDatasetSlugAutomationsIndexRoute:
    DashboardDatasetSlugAutomationsIndexRoute,
  DashboardDatasetSlugDocsIndexRoute: DashboardDatasetSlugDocsIndexRoute,
  DashboardDatasetSlugLibraryIndexRoute: DashboardDatasetSlugLibraryIndexRoute,
  DashboardDatasetSlugNotesIndexRoute: DashboardDatasetSlugNotesIndexRoute,
  DashboardDatasetSlugSupportIndexRoute: DashboardDatasetSlugSupportIndexRoute,
  DashboardDatasetSlugTasksIndexRoute: DashboardDatasetSlugTasksIndexRoute,
  DashboardDatasetSlugAppsInstalledAppIdRoute:
    DashboardDatasetSlugAppsInstalledAppIdRoute,
  DashboardDatasetSlugAutomationsAutomationIdBuilderRoute:
    DashboardDatasetSlugAutomationsAutomationIdBuilderRoute,
  DashboardDatasetSlugAutomationsAutomationIdLogsRoute:
    DashboardDatasetSlugAutomationsAutomationIdLogsRouteWithChildren,
  DashboardDatasetSlugDataCandidatesCandidateIdRoute:
    DashboardDatasetSlugDataCandidatesCandidateIdRoute,
  DashboardDatasetSlugDataCandidatesCreateRoute:
    DashboardDatasetSlugDataCandidatesCreateRoute,
  DashboardDatasetSlugDataCandidatesSettingsRoute:
    DashboardDatasetSlugDataCandidatesSettingsRoute,
  DashboardDatasetSlugDataClientsClientIdRoute:
    DashboardDatasetSlugDataClientsClientIdRoute,
  DashboardDatasetSlugDataClientsCreateRoute:
    DashboardDatasetSlugDataClientsCreateRoute,
  DashboardDatasetSlugDataClientsSettingsRoute:
    DashboardDatasetSlugDataClientsSettingsRoute,
  DashboardDatasetSlugDataContactsContactIdRoute:
    DashboardDatasetSlugDataContactsContactIdRoute,
  DashboardDatasetSlugDataContactsCreateRoute:
    DashboardDatasetSlugDataContactsCreateRoute,
  DashboardDatasetSlugDataContactsSettingsRoute:
    DashboardDatasetSlugDataContactsSettingsRoute,
  DashboardDatasetSlugDataCustomCreateRoute:
    DashboardDatasetSlugDataCustomCreateRoute,
  DashboardDatasetSlugDataJobsJobIdRoute:
    DashboardDatasetSlugDataJobsJobIdRoute,
  DashboardDatasetSlugDataJobsCreateRoute:
    DashboardDatasetSlugDataJobsCreateRoute,
  DashboardDatasetSlugDataJobsSettingsRoute:
    DashboardDatasetSlugDataJobsSettingsRoute,
  DashboardDatasetSlugDataListsListIdRoute:
    DashboardDatasetSlugDataListsListIdRoute,
  DashboardDatasetSlugDataPlacementsSettingsRoute:
    DashboardDatasetSlugDataPlacementsSettingsRoute,
  DashboardDatasetSlugDataSkillsSkillIdRoute:
    DashboardDatasetSlugDataSkillsSkillIdRoute,
  DashboardDatasetSlugDataSkillsReviewRoute:
    DashboardDatasetSlugDataSkillsReviewRoute,
  DashboardDatasetSlugDataSkillsSettingsRoute:
    DashboardDatasetSlugDataSkillsSettingsRoute,
  DashboardDatasetSlugNotesIdEditRoute: DashboardDatasetSlugNotesIdEditRoute,
  DashboardDatasetSlugAutomationsAutomationIdIndexRoute:
    DashboardDatasetSlugAutomationsAutomationIdIndexRoute,
  DashboardDatasetSlugDataCandidatesIndexRoute:
    DashboardDatasetSlugDataCandidatesIndexRoute,
  DashboardDatasetSlugDataClientsIndexRoute:
    DashboardDatasetSlugDataClientsIndexRoute,
  DashboardDatasetSlugDataContactsIndexRoute:
    DashboardDatasetSlugDataContactsIndexRoute,
  DashboardDatasetSlugDataCvSendsIndexRoute:
    DashboardDatasetSlugDataCvSendsIndexRoute,
  DashboardDatasetSlugDataJobSubmissionsIndexRoute:
    DashboardDatasetSlugDataJobSubmissionsIndexRoute,
  DashboardDatasetSlugDataJobsIndexRoute:
    DashboardDatasetSlugDataJobsIndexRoute,
  DashboardDatasetSlugDataListsIndexRoute:
    DashboardDatasetSlugDataListsIndexRoute,
  DashboardDatasetSlugDataPlacementsIndexRoute:
    DashboardDatasetSlugDataPlacementsIndexRoute,
  DashboardDatasetSlugDataSkillsIndexRoute:
    DashboardDatasetSlugDataSkillsIndexRoute,
  DashboardDatasetSlugDataCandidatesEditIdRoute:
    DashboardDatasetSlugDataCandidatesEditIdRoute,
  DashboardDatasetSlugDataCandidatesViewViewNameRoute:
    DashboardDatasetSlugDataCandidatesViewViewNameRoute,
  DashboardDatasetSlugDataClientsEditIdRoute:
    DashboardDatasetSlugDataClientsEditIdRoute,
  DashboardDatasetSlugDataClientsViewViewNameRoute:
    DashboardDatasetSlugDataClientsViewViewNameRoute,
  DashboardDatasetSlugDataContactsEditIdRoute:
    DashboardDatasetSlugDataContactsEditIdRoute,
  DashboardDatasetSlugDataContactsViewViewNameRoute:
    DashboardDatasetSlugDataContactsViewViewNameRoute,
  DashboardDatasetSlugDataJobsEditIdRoute:
    DashboardDatasetSlugDataJobsEditIdRoute,
  DashboardDatasetSlugDataJobsViewViewNameRoute:
    DashboardDatasetSlugDataJobsViewViewNameRoute,
  DashboardDatasetSlugDataSkillsSetsSet_idRoute:
    DashboardDatasetSlugDataSkillsSetsSet_idRoute,
  DashboardDatasetSlugDataSkillsSetsIndexRoute:
    DashboardDatasetSlugDataSkillsSetsIndexRoute,
  DashboardDatasetSlugchatsChatsConversationIdSearchesSearchIdRoute:
    DashboardDatasetSlugchatsChatsConversationIdSearchesSearchIdRoute,
  DashboardDatasetSlugDataCustomDetailsIdCreateRoute:
    DashboardDatasetSlugDataCustomDetailsIdCreateRoute,
  DashboardDatasetSlugDataCustomDetailsIdKanbanRoute:
    DashboardDatasetSlugDataCustomDetailsIdKanbanRoute,
  DashboardDatasetSlugDataCustomDetailsIdSettingsRoute:
    DashboardDatasetSlugDataCustomDetailsIdSettingsRoute,
  DashboardDatasetSlugDataCustomDetailsIdEditRowIdRoute:
    DashboardDatasetSlugDataCustomDetailsIdEditRowIdRoute,
  DashboardDatasetSlugDataCustomDetailsIdTableCustomDetailsIdRoute:
    DashboardDatasetSlugDataCustomDetailsIdTableCustomDetailsIdRoute,
  DashboardDatasetSlugDataCustomDetailsIdViewViewNameRoute:
    DashboardDatasetSlugDataCustomDetailsIdViewViewNameRoute,
  DashboardDatasetSlugDataCustomDetailsIdTableIndexRoute:
    DashboardDatasetSlugDataCustomDetailsIdTableIndexRoute,
}

const DashboardDatasetSlugRouteWithChildren =
  DashboardDatasetSlugRoute._addFileChildren(DashboardDatasetSlugRouteChildren)

interface DashboardRouteChildren {
  DashboardDatasetSlugRoute: typeof DashboardDatasetSlugRouteWithChildren
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardDatasetSlugRoute: DashboardDatasetSlugRouteWithChildren,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

interface OauthRouteChildren {
  OauthOauthResponseRoute: typeof OauthOauthResponseRoute
  OauthOauthVerifyLinkAccountRequestRoute: typeof OauthOauthVerifyLinkAccountRequestRoute
  OauthOauthVerifyNewAccountRequestRoute: typeof OauthOauthVerifyNewAccountRequestRoute
  OauthOauthVerifyNewUserSignupRoute: typeof OauthOauthVerifyNewUserSignupRoute
}

const OauthRouteChildren: OauthRouteChildren = {
  OauthOauthResponseRoute: OauthOauthResponseRoute,
  OauthOauthVerifyLinkAccountRequestRoute:
    OauthOauthVerifyLinkAccountRequestRoute,
  OauthOauthVerifyNewAccountRequestRoute:
    OauthOauthVerifyNewAccountRequestRoute,
  OauthOauthVerifyNewUserSignupRoute: OauthOauthVerifyNewUserSignupRoute,
}

const OauthRouteWithChildren = OauthRoute._addFileChildren(OauthRouteChildren)

interface PublicRouteChildren {
  PublicLoginRoute: typeof PublicLoginRoute
  PublicMagicLinkSentRoute: typeof PublicMagicLinkSentRoute
  PublicMfaRoute: typeof PublicMfaRoute
  PublicOpenapiOauthRoute: typeof PublicOpenapiOauthRoute
  PublicSelectDatasetRoute: typeof PublicSelectDatasetRoute
  PublicVerifyRoute: typeof PublicVerifyRoute
  PublicVerifyUserDatasetRoute: typeof PublicVerifyUserDatasetRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicLoginRoute: PublicLoginRoute,
  PublicMagicLinkSentRoute: PublicMagicLinkSentRoute,
  PublicMfaRoute: PublicMfaRoute,
  PublicOpenapiOauthRoute: PublicOpenapiOauthRoute,
  PublicSelectDatasetRoute: PublicSelectDatasetRoute,
  PublicVerifyRoute: PublicVerifyRoute,
  PublicVerifyUserDatasetRoute: PublicVerifyUserDatasetRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  R404Route: R404Route,
  DashboardRoute: DashboardRouteWithChildren,
  OauthRoute: OauthRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
